/**
 * Script
 *
 * @author Space-Time Inc.
 * @version 2023-02-10
 */
/* eslint-disable no-lone-blocks */
/* eslint-disable no-undef */

'use strict';

window['ST'] = window['ST'] || {};

((NS) => {
	document.addEventListener('DOMContentLoaded', () => {
		NS.initializeQuerySelectorAll('.user-content');

		const as = document.querySelectorAll('[data-nc-links] a, [data-nc-links-ns] a');
		NS.link.applyType(as, { observedSelector: 'main' });
		if (!CSS.supports('scroll-behavior', 'smooth')) {
			NS.link.applySmooth(as, { observedSelector: 'main' });
		} else {
			window.addEventListener('load', () => {
				document.documentElement.style.scrollBehavior = 'smooth';
			});
		}

		const ks = document.querySelectorAll('[data-nc-kerning]');
		NS.ja.applyKerning(ks, { doAssignAttribute: false, doDisableOnSelecting: true });

		const ss = document.querySelectorAll('[data-nc-segmenter]');
		NS.ja.applySegmenter(ss, { doDisableOnSelecting: true });
	});

	/**
	 * Scroll Padding Top
	 *
	 * @author Takuto Yanagida
	 * @version 2023-02-10
	 */
	
	function initializeScrollPaddingTop() {
		const de = document.documentElement;
		if (de.getAttribute('data-scroll-padding-top') !== null) return;
		de.setAttribute('data-scroll-padding-top', '');
	
		const mo = new MutationObserver((ms, mo) => update(mo));
		mo.observe(de, { attributes: true });
		update(mo);
	
		function update(mo) {
			const de = document.documentElement;
	
			mo.disconnect();
			de.style.scrollPaddingTop = null;
	
			const v = parseInt(getComputedStyle(de).scrollPaddingTop);
			setScrollPaddingTop('default', Number.isNaN(v) ? 0 : v);
	
			de.style.scrollPaddingTop = getScrollPaddingTop() + 'px';
			mo.observe(de, { attributes: true });
		}
	}
	
	function setScrollPaddingTop(key, val) {
		const de = document.documentElement;
		const at = de.getAttribute('data-scroll-padding-top');
		const vs = at ? new Map(at.split(',').map(e => e.split(':'))) : new Map();
		if (val) {
			vs.set(key, val);
		} else {
			vs.delete(key);
		}
		de.setAttribute('data-scroll-padding-top', [...vs].map(e => e.join(':')).join(','));
	}
	
	function getScrollPaddingTop(without = null) {
		const de = document.documentElement;
		const at = de.getAttribute('data-scroll-padding-top');
		if (!at) return 0;
	
		const vs = at.split(',').map(e => e.split(':')).filter(([key,]) => key !== without).map(([k, v]) => parseInt(v));
		return vs.reduce((a, b) => a + b, 0);
	}
	
	/**
	 * Style Class Utilities
	 *
	 * @author Takuto Yanagida
	 * @version 2021-11-11
	 */
	
	function hasClass(tar, cls) {
		const key = cls.substr(1);
		if (cls.startsWith(':')) {
			return tar.dataset[key] !== undefined;
		} else {
			return tar.classList.contains(key);
		}
	}
	
	function setClass(tar, cls, enabled = true, val = '') {
		const key = cls.substr(1);
		if (cls.startsWith(':')) {
			if (enabled) {
				tar.dataset[key] = val;
			} else {
				delete tar.dataset[key];
			}
		} else {
			const c = [key, val].join('-');
			if (enabled) {
				tar.classList.add(c);
			} else {
				tar.classList.remove(c);
			}
		}
	}
	
	function getSelector(cls) {
		if (cls.startsWith(':')) {
			return `*[data-${cls.substr(1).replace(/([A-Z])/g, c => '-' + c.charAt(0).toLowerCase())}]`;
		} else {
			return `*${cls}`;
		}
	}
	
	/**
	 * Utilities
	 *
	 * @author Takuto Yanagida
	 * @version 2023-01-05
	 */
	
	function getScrollOffset() {
		const s   = getComputedStyle(document.documentElement);
		const val = parseInt(s.scrollPaddingTop);
		return Number.isNaN(val) ? 0 : val;
	}
	
	
	// -----------------------------------------------------------------------------
	
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
	const resizeListeners = [];
	const scrollListeners = [];
	
	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}
	
	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}
	
	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});
	
	
	// -----------------------------------------------------------------------------
	
	
	function onIntersect(fn, targets, threshold = 0, rootMargin = '* 0px 0px 0px') {
		const vs = Array(targets.length).fill(false);
		const tm = new Map();
		targets.forEach((t, i) => tm.set(t, i));
	
		function init() {
			const io = new IntersectionObserver((es) => {
				for (const e of es) vs[tm.get(e.target)] = e.isIntersecting;
				fn(vs);
			}, { rootMargin: rootMargin.replace('*', `${mt}px`), threshold });
			for (const t of targets) io.observe(t);
			return io;
		}
		let mt = 0;
		let io = null;
		let st = null;
		onResize(() => {
			mt = -getScrollOffset();
			if (st) clearTimeout(st);
			st = setTimeout(() => {
				if (io) io.disconnect();
				io = init();
			}, 100);
		}, true);
	}
	
	{
		/**
		 * Script
		 *
		 * @author Space-Time Inc.
		 * @version 2023-02-01
		 */
		
		function initialize(ns, target) {
			// Delay
		
			const is  = [...target.getElementsByTagName('img')];
			const tis = [...target.querySelectorAll('table img')];
			const ifs = [...target.getElementsByTagName('iframe')];
		
			ns.delay.applyImage(is.filter(e => !tis.includes(e)));
			ns.delay.applyIframe(ifs);
		
			// Container
		
			const ms = target.querySelectorAll('*[class^="masonry-"]');
			ns.container.applyMasonry(ms);
		
			// Content
		
			const figs = target.getElementsByTagName('figure');
			const ss   = target.getElementsByTagName('span');
		
			ns.content.applyImageAlt(is);
			ns.content.applyFigureCaption(figs);
			ns.content.applyIframeAspect(ifs);
			ns.content.applyUnderline(ss);
		
			// Link
		
			const as = target.querySelectorAll('a');
			ns.link.applyType(as, { observedSelector: 'main' });
			if (!CSS.supports('scroll-behavior', 'smooth')) {
				ns.link.applySmooth(as, { observedSelector: 'main' });
			}
		
			// Japanese Text
		
			const sgs = [...target.getElementsByClassName('segmenter')];
			for (const h of [1, 2, 3, 4, 5, 6]) {
				const ts = target.querySelectorAll(`h${h}:not([class])`);
				for (const t of ts) sgs.push(t);
			}
		
			ns.ja.applySegmenter(sgs, { properNouns: [] });
			ns.ja.applyKerning([target], { doAssignAttribute: false, doDisableOnSelecting: false });
		
			// Align
		
			const left  = [...target.getElementsByClassName('alignleft')];
			const right = [...target.getElementsByClassName('alignright')];
			ns.align.applyFloat({ left, right }, {});
		
			// List
		
			const uls = target.getElementsByTagName('ul');
			ns.list.applyCustom(uls);
		
			// Tab
		
			const tsc = target.querySelectorAll('.tab-scroll, .pseudo-tab-page');
			const tst = target.querySelectorAll('.tab-stack, .tab-page');
			ns.tab.applyScroll(tsc);
			ns.tab.applyStack(tst, { doUseBarBelow: false });
		
			// Table
		
			const tables = target.getElementsByTagName('table');
		
			ns.table.applyNeatWidth(tables);
			ns.table.applyUsableView(tables);
		
			// Viewer
		
			const if_os  = [...target.getElementsByClassName('iframe-opener')];
			const os_ifs = [...target.querySelectorAll('.iframe-opener + iframe')];
			const a_img  = [...target.querySelectorAll('a[data-nc-link-image][data-nc-link-to-image]')];
		
			ns.viewer.applyIframe(if_os, os_ifs);
			ns.viewer.applyImage(a_img);
		
			// Utility
		
			ns.utility.applyBlank();
			ns.utility.applyDimension();
		
			// Scroll Effect
		
			const ts = target.querySelectorAll('[data-nc-scroll-effect]');
			ns.scroll.apply(ts);
		}
		
		NS.initializeQuerySelector = function (s) {
			const t = document.querySelector(s);
			initialize(NS, t);
		};
		NS.initializeQuerySelectorAll = function (s) {
			const ts = document.querySelectorAll(s);
			for (const t of ts) initialize(NS, t);
		};
	}

	// Align -------------------------------------------------------------------
	NS['align'] = {};
	{
		/**
		 *
		 * Float
		 *
		 * @author Takuto Yanagida
		 * @version 2024-06-04
		 *
		 */
		
		
		function apply(tars = {}, opts = {}) {
			tars = Object.assign({ left: [], right: [] }, tars);
			if (tars['left'].length + tars['right'].length === 0 ) return;
		
			opts = Object.assign({
				styleAlign : ':ncAlign',
				classLeft  : 'alignleft',
				classRight : 'alignright',
				classCenter: 'aligncenter',
				minWidth   : 240,  // px
			}, opts);
		
			setTimeout(() => {
				assignEventListener(tars['left'], opts['classLeft'], opts);
				assignEventListener(tars['right'], opts['classRight'], opts);
			}, 0);  // Delay
		}
		
		async function assignEventListener(as, cls, opts) {
			const aws = as.map(e => [e, 0]);
			storeWidth(aws, cls, opts);
			onResize(() => update(aws, cls, opts), true);
		}
		
		
		// -------------------------------------------------------------------------
		
		
		async function storeWidth(aws, cls, opts) {
			while (true) {
				let doUpdate = false;
				let count    = 0;
				for (const aw of aws) {
					const [a, w] = aw;
					if (10 < w) {
						count += 1;
						continue;
					}
					aw[1] = a.getBoundingClientRect().width;
					doUpdate = true;
				}
				if (doUpdate) {
					update(aws, cls, opts)
				}
				if (count === aws.length) {
					break;
				}
				await new Promise(r => setTimeout(r, 100));
			}
		}
		
		function update(aws, cls, opts) {
			for (const aw of aws) {
				const [a, w] = aw;
				const cw = contentWidth(a.parentElement);
				const wn = a.getBoundingClientRect().width;
				if (wn < cw * 0.9 && w < wn) {
					aw[1] = wn;
				}
			}
			for (const [a, w] of aws) {
				const cw = contentWidth(a.parentElement, true);
				switchFloatOne(a, cw - w < opts.minWidth, cls, opts);
			}
		}
		
		function switchFloatOne(a, enabled, origCls, opts) {
			if (enabled && !hasClass(a, opts.styleAlign)) {
				setClass(a, opts.styleAlign, true, origCls);
				a.classList.remove(origCls);
				a.classList.add(opts.classCenter);
			}
			if (!enabled && hasClass(a, opts.styleAlign)) {
				a.classList.remove(opts.classCenter);
				a.classList.add(origCls);
				setClass(a, opts.styleAlign, false);
			}
		}
		
		function contentWidth(e, checkDisplay = false) {
			if (e === null) {
				return window.innerWidth;
			}
			const s = getComputedStyle(e);
			if (checkDisplay && s.display === 'inline') {
				return contentWidth(e.parentElement);
			}
			const ph = parseFloat(s.paddingLeft) + parseFloat(s.paddingRight);
			return e.clientWidth - ph;
		}
		
		NS.align.applyFloat = apply;
	}

	// Container ---------------------------------------------------------------
	NS['container'] = {};
	{
		/**
		 * Masonry
		 *
		 * @author Takuto Yanagida
		 * @version 2023-03-21
		 */
		
		function apply(ts) {
			for (const t of ts) new Masonry(t);
		}
		
		
		// -------------------------------------------------------------------------
		
		
		class Masonry {
			#cont;
			#its;
		
			static NS = '--nc-container-masonry-';
		
			constructor(cont) {
				this.#cont = cont instanceof Node ? cont : document.querySelector(cont);
				this.#its  = this.#cont.querySelectorAll(':scope > *');
		
				function throttle(fn) {
					let isRunning;
					return (...args) => {
						if (isRunning) return;
						isRunning = true;
						requestAnimationFrame(() => {
							isRunning = false;
							fn(...args);
						});
					};
				}
		
				if (this.#cont && this.#its.length) {
					const ro = new ResizeObserver(throttle(() => this.#layOut()));
					ro.observe(this.#cont);
					for (const it of this.#its) {
						ro.observe(it);
					}
					const mo = new MutationObserver(throttle(() => {
						this.#its = this.#cont.querySelectorAll(':scope > *');
						this.#layOut();
					}));
					mo.observe(this.#cont, { childList: true });
				}
			}
		
			#layOut() {
				this.#cont.style.removeProperty(Masonry.NS + 'position');
				this.#cont.style.removeProperty(Masonry.NS + 'width');
		
				for (const it of this.#its) {
					it.style.translate = '';
				}
				const { gx, gy, cw } = this.#getBaseSize();
				const cols = this.#getColumCount();
		
				this.#cont.style.setProperty(Masonry.NS + 'position', 'absolute');
				this.#cont.style.setProperty(Masonry.NS + 'width', `${cw}px`);
		
				const xs = [];
				const ys = [];
		
				for (let i = 0; i < cols; ++i) {
					xs.push(i * (cw + gx));
					ys.push(0);
				}
				for (const it of this.#its) {
					const r = it.getBoundingClientRect();
					if (!r.width && !r.height) continue;
		
					const i = ys.indexOf(this.#min(ys, gy * 2));
					it.style.translate = `${xs[i]}px ${0 | ys[i]}px`;
					ys[i] += r.height + gy;
				}
				this.#cont.style.height = `${Math.max(0, Math.ceil(Math.max(...ys) - gy))}px`;
			}
		
			#min(ys, f) {
				let v = ys[0];
				for (let i = 1; i < ys.length; i += 1) {
					if (ys[i] + f < v) {
						v = ys[i];
					}
				}
				return v;
			}
		
			#getBaseSize() {
				const s  = window.getComputedStyle(this.#cont);
				const gx = s.columnGap ? parseInt(s.columnGap) : 0;
				const gy = s.rowGap    ? parseInt(s.rowGap)    : 0;
		
				let cw = 0;
				for (const it of this.#its) {
					const r = it.getBoundingClientRect();
					if (!r.width && !r.height) continue;
		
					cw = Math.floor(r.width);
					break;
				}
				return { gx, gy, cw };
			}
		
			#getColumCount() {
				let y = null;
				let c = 0;
		
				for (const it of this.#its) {
					const r = it.getBoundingClientRect();
					if (!r.width && !r.height) continue;
		
					if (null === y) y = r.y;
					if (y !== r.y) return c;
					c += 1;
				}
				return c;
			}
		}
		
		NS.container.applyMasonry = apply;
	}

	// Content -----------------------------------------------------------------
	NS['content'] = {};
	{
		/**
		 * Image Alt
		 *
		 * @author Takuto Yanagida
		 * @version 2021-12-26
		 */
		
		function apply(ts) {
			for (const t of ts) {
				if (!t.alt && t.src) {
					let src = t.src.trim();
					if (src.endsWith('/')) src = src.substring(0, src.length - 1);
					const idx = src.lastIndexOf('/');
					if (idx === -1) continue;
					t.alt = src.substring(idx + 1);
				}
			}
		}
		
		NS.content.applyImageAlt = apply;
	}
	{
		/**
		 * Figure Caption
		 *
		 * @author Takuto Yanagida
		 * @version 2022-10-13
		 */
		
		// Wrap figure captions with spans for Firefox
		function apply(figs) {
			const ua = window.navigator.userAgent.toLowerCase();
			if (ua.includes('firefox')) {
				for (const fig of figs) {
					fig.style.width = '';
		
					const fcs = fig.getElementsByTagName('figcaption');
					const fc  = fcs.length ? fcs[0] : null;
					if (fc) {
						fc.innerHTML = `<div>${fc.innerHTML}</div>`;
					}
				}
			}
		}
		
		NS.content.applyFigureCaption = apply;
	}
	{
		/**
		 * Iframe Aspect
		 *
		 * @author Takuto Yanagida
		 * @version 2023-05-18
		 */
		
		function apply(fs) {
			for (const f of fs) {
				if (!f.style.aspectRatio) {
					setAspectRatio(f);
				}
			}
			observe(fs);
		}
		
		function observe(fs) {
			if (!fs.length) return;
			const mo = new MutationObserver(rs => {
				for (const r of rs) setAspectRatio(r.target);
			});
			for (const f of fs) {
				mo.observe(f, { attributes: true });
			}
		}
		
		function setAspectRatio(f) {
			const [w, h] = extractIframeSize(f);
			if (w && h) {
				f.style.aspectRatio = `${w} / ${h}`;
			}
		}
		
		function extractIframeSize(f) {
			let w = parseInt(f.width);
			let h = parseInt(f.height);
			if (w && h) return [w, h];
		
			const sW = f.style.width;
			const sH = f.style.height;
			if (!sW.endsWith('px') || !sH.endsWith('px')) return [0, 0];
			w = parseInt(sW);
			h = parseInt(sH);
			if (w && h) return [w, h];
			return [0, 0];
		}
		
		NS.content.applyIframeAspect = apply;
	}
	{
		/**
		 * Underline
		 *
		 * @author Takuto Yanagida
		 * @version 2021-12-27
		 */
		
		function apply(spans, opts = {}) {
			opts = Object.assign({
				styleList: ':ncUnderline',
			}, opts);
		
			for (const span of spans) {
				setStyle(span, opts);
			}
		}
		
		function setStyle(t, opts) {
			let type = t.style.textDecorationLine;
			if (type === '') type = t.style.textDecoration;  // For Safari
		
			if (type === 'underline') {
				const re = new RegExp('^text-decoration\\s*:\\s*' + type + '\\s*;?$', 'gi');
				if (t.getAttribute('style').trim().match(re)) {
					t.removeAttribute('style');
				} else {
					if (t.style.textDecorationLine !== '') {
						t.style.textDecorationLine = '';
					} else {
						t.style.textDecoration = '';
					}
				}
				setClass(t, opts.styleList);
			}
		}
		
		NS.content.applyUnderline = apply;
	}

	// Delay Loading -----------------------------------------------------------
	NS['delay'] = {};
	{
		{
			/**
			 *
			 * Image
			 *
			 * @author Takuto Yanagida
			 * @version 2022-07-11
			 *
			 */
			
			
			const BLANK_IMG = 'data:image/gif;base64,R0lGODdhAQABAPAAAP///wAAACwAAAAAAQABAEACAkQBADs=';
			
			
			function apply(ts, opts = {}) {
				if (ts.length === 0) return;
			
				opts = Object.assign({
					offset    : 100,
					blankImage: BLANK_IMG,
					doForce   : true,
				}, opts);
			
				for (const t of ts) {
					if (t.getAttribute('loading')) {
						t.setAttribute('loading', 'lazy');
					}
				}
			
				if (isPolyfillNeeded(HTMLImageElement.prototype)) {  // For old browsers.
					setPolyfill(ts, opts);
				} else if (opts['doForce']) {
					const np = ts.filter(e => !e.getAttribute('loading'));
					setPolyfill(np, opts);
				}
			
				window.addEventListener('beforeprint', () => {
					for (const t of ts) {
						if (t.dataset.src) {
							show(t);
						}
						if (t.getAttribute('loading') === 'lazy') {
							t.setAttribute('loading', 'eager');
						}
					}
				}, false);
			}
			
			function setPolyfill(ts, opts) {
				for (const t of ts) {
					hide(t, opts['blankImage']);
				}
				onIntersect(vs => {
					for (let i = 0; i < ts.length; i += 1) {
						const t = ts[i];
						if (t.dataset.src && vs[i]) {
							show(t);
						}
					}
				}, ts, 0, `* 0px ${opts['offset']}px 0px`);
			}
			
			function hide(t, blankImage) {
				saveAttribute(t, 'src', blankImage);
				saveAttribute(t, 'srcset');
				t.style.opacity = 0;
				const h = t.getAttribute('height');
				if (h) {
					t.style.minHeight = h + 'px';
				}
			}
			
			function show(t) {
				t.addEventListener('load', () => {
					t.style.minHeight = '';
					t.style.opacity   = '';
				});
				restoreAttribute(t, 'src');
				restoreAttribute(t, 'srcset');
			}
			
			NS.delay.applyImage = apply;

			NS.delay.isPolyfillNeededForImage = () => isPolyfillNeeded(HTMLImageElement.prototype);
		}
		{
			/**
			 *
			 * Iframe
			 *
			 * @author Takuto Yanagida
			 * @version 2021-12-26
			 *
			 */
			
			
			function apply(ts, opts = {}) {
				if (ts.length === 0) return;
			
				opts = Object.assign({
					offset : 100,
					doForce: true,
				}, opts);
			
				if (isPolyfillNeeded(HTMLIFrameElement.prototype)) {  // For Safari
					setPolyfill(ts, opts);
				} else if (opts['doForce']) {
					const np = ts.filter(e => !e.getAttribute('loading'));
					setPolyfill(np, opts);
				}
			
				window.addEventListener('beforeprint', () => {
					for (const t of ts) {
						if (t.dataset.src) {
							show(t);
						}
						if (t.getAttribute('loading') === 'lazy') {
							t.setAttribute('loading', 'eager');
						}
					}
				}, false);
			}
			
			function setPolyfill(ts, opts) {
				for (const t of ts) {
					console.log(t);
					hide(t);
				}
				onIntersect(vs => {
					for (let i = 0; i < ts.length; i += 1) {
						const t = ts[i];
						if (t.dataset.src && vs[i]) {
							show(t);
						}
					}
				}, ts, 0, `* 0px ${opts['offset']}px 0px`);
			}
			
			function hide(t) {
				saveAttribute(t, 'src');
			}
			
			function show(t) {
				const v = t.dataset['src'];
				if (v) {
					if (t.contentDocument) {
						t.contentDocument.location.replace(v);
					} else {
						t.setAttribute('src', v);
					}
					delete t.dataset['src'];
				}
			}
			
			NS.delay.applyIframe = apply;

			NS.delay.isPolyfillNeededForIframe = () => isPolyfillNeeded(HTMLIFrameElement.prototype);
		}
		/**
		 *
		 * Common Functions
		 *
		 * @author Takuto Yanagida
		 * @version 2021-11-11
		 *
		 */
		
		
		function saveAttribute(t, at, alt = null) {
			const v = t.getAttribute(at);
			if (v) {
				t.dataset[at] = v;
				if (alt) {
					t.setAttribute(at, alt);
				} else {
					t.removeAttribute(at);
				}
			}
		}
		
		function restoreAttribute(t, at) {
			const v = t.dataset[at];
			if (v) {
				t.setAttribute(at, v);
				delete t.dataset[at];
			}
		}
		
		function isPolyfillNeeded(proto) {
			return (!('loading' in proto));
		}
		
	}

	// Japanese Text -----------------------------------------------------------
	NS['ja'] = {};
	{
		{
			/**
			 * Kerning
			 *
			 * @author Takuto Yanagida
			 * @version 2024-03-27
			 */
			
			function apply(ts, opts = {}) {
				if (ts.length === 0) return;
				if (CSS.supports('text-spacing-trim', 'normal')) return;
			
				opts = Object.assign({
					styleKerning        : ':ncKern',
					styleDisabled       : ':ncNoKerning',
					ignoredTags         : ['PRE'],
					doAssignAttribute   : true,
					doDisableOnSelecting: true,
				}, opts);
				opts.ignoredTags = opts.ignoredTags.map(e => e.toUpperCase());
			
				for (const t of ts) {
					kernElement(t, dict, opts);
					if (opts['doAssignAttribute'] && opts['doDisableOnSelecting']) {
						const f = () => {
							removeKerning(t, opts);
							t.removeEventListener('selectstart', f);
						};
						t.addEventListener('selectstart', f);
					}
				}
			}
			
			function removeKerning(elm, opts) {
				for (const s of [...elm.getElementsByTagName('span')]) {
					if (hasClass(s, opts.styleKerning)) {
						const df = document.createDocumentFragment();
						for (const c of [...s.childNodes]) {
							df.appendChild(c);
						}
						s.parentNode.replaceChild(df, s);
					}
				}
			}
			
			function applyToString(str, opts = {}) {
				opts = Object.assign({
					styleKerning     : ':ncKern',
					styleDisabled    : ':ncNoKerning',
					doAssignAttribute: true,
				}, opts);
			
				const ks = getKerning(str, dict, false, opts.doAssignAttribute);
				if (ks.length) {
					return createFragment(str, ks, opts);
				}
				return null;
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function kernElement(elm, dict, opts) {
				for (const c of [...elm.childNodes]) {
					if (c.nodeType === 1) {  // ELEMENT_NODE
						if (!hasClass(c, opts.styleDisabled) && !opts.ignoredTags.includes(c.tagName)) {
							kernElement(c, dict, opts);
						}
					} else if (c.nodeType === 3) {  // TEXT_NODE
						kernTextNode(c, dict, opts);
					}
				}
			}
			
			function kernTextNode(tn, dict, opts) {
				const [isHead, isTail] = isEnd(tn);
			
				let str = tn.textContent;
				if (isHead) str = removeHeadWhiteSpaces(str);
				if (isTail) str = removeTailWhiteSpaces(str);
				str = removeWhiteSpacesBetweenZenChars(str);
			
				let nt = '';
				if (tn.nextSibling && tn.nextSibling.nodeType === 1 && getComputedStyle(tn.nextSibling).display === 'inline') {
					nt = tn.nextSibling.innerText;
				}
				if (!tn.nextSibling && tn.parentNode.nextSibling) {
					const parentNext = tn.parentNode.nextSibling;
					if (parentNext.nodeType === 1) {  // ELEMENT_NODE
						const pnd = getComputedStyle(parentNext).display;
						if (pnd.includes('inline')) {
							nt = parentNext.innerText;
						}
					}
					if (parentNext.nodeType === 3) {  // TEXT_NODE
						nt = parentNext.textContent;
					}
				}
			
				const ks = getKerning(str, dict, isHead, nt, opts.doAssignAttribute);
				if (ks.length) {
					const f = createFragment(str, ks, opts);
					tn.parentNode.replaceChild(f, tn);
				}
			}
			
			function isEnd(tn) {
				const p = tn.parentNode;
				if (!(p instanceof HTMLElement)) return [false, false];
				const pd = getComputedStyle(p).display;
				if (!pd.includes('inline')) {  // Block
					return isSiblingBlock(tn);
				}
				if (pd === 'inline-block') {  // Inline block
					if (p.childNodes.length !== 1) {  // The parent has multiple nodes.
						return isSiblingBlock(tn);
					}
					const pp = p.parentNode;
					if (pp) {
						const ppd = getComputedStyle(pp).display;
						if (!ppd.includes('inline')) {
							return isSiblingBlock(p, true);
						}
					}
				}
				return [false, false];  // Not inline block
			}
			
			function isSiblingBlock(n, greedy = false) {
				return [greedy ? isPreviousBlockGreedy(n.previousSibling) : isBlock(n.previousSibling), isBlock(n.nextSibling)];
			}
			
			function isBlock(n) {
				if (n === null) return true;
				if (!(n instanceof HTMLElement)) return false;
				if (n.tagName === 'BR') return true;
				return !getComputedStyle(n).display.includes('inline');
			}
			
			function isPreviousBlockGreedy(n) {
				while (true) {
					if (n === null) return true;
					if (n.nodeType === 1) {
						if (n.tagName === 'BR') return true;
						return !getComputedStyle(n).display.includes('inline');
					}
					if (n.nodeType === 3) {
						if (!n.textContent.trim()) return true;
					}
					n = n.previousSibling;
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function getKerning(str, dict, isHead, nextNodeText, assignAttr) {
				let strArray = [...str];
				const ret = [];
			
				if (nextNodeText.length) {
					strArray = strArray.concat([...nextNodeText]);
				}
				let l = 0;
			
				for (let i = 0; i < strArray.length; i += 1) {
					const c0 = strArray[i];
					const c1 = strArray[i + 1];
			
					let a = '';
					if (c0 !== '' && c1 !== '' && dict.has(c0 + c1)) {
						a = assignAttr ? 's' : 'letter-spacing:-0.4em;';
					}
					if (i === 0 && isHead && c0 !== '' && dict.has(c0)) {
						a += assignAttr ? 'h' : 'margin-left:-0.4em';
					}
					if (a.length) {
						if (l) {
							ret.push(l);
							l = 0;
						}
						ret.push(a);
					} else {
						l += 1;
					}
				}
				if (ret.length && l) ret.push(l);
				return ret;
			}
			
			function createFragment(str, ks, opts) {
				const strArray = [...str];
				const f = document.createDocumentFragment();
				let i = 0;
				for (const k of ks) {
					if (Number.isInteger(k)) {
						const n = document.createTextNode(strArray.slice(i, i + k).join(''));
						f.appendChild(n);
						i += k;
					} else {
						const n = document.createElement('span');
						n.appendChild(document.createTextNode(strArray.slice(i, i + 1).join('')));
						if (k.length <= 2) {
							setClass(n, opts.styleKerning, true, k);
						} else {
							n.style = k;
						}
						f.appendChild(n);
						i += 1;
					}
				}
				return f;
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			const dict = new Set();
			{
				addPairs(dict, '、，。．・｜：　', '「『（［｛〈《【〔');
				addPairs(dict, '」』）］｝〉》】〕', '、，。．・｜：,.');
				addPairs(dict, '」』）］｝〉》】〕', '「『（［｛〈《【〔');
				addPairs(dict, '「『（［｛〈《【〔', '「『（［｛〈《【〔');
				addPairs(dict, '」』）］｝〉》】〕', '」』）］｝〉》】〕');
				addSolos(dict, '「『（［｛〈《【〔');
			
				function addPairs(dict, cs0, cs1) {
					for (const c0 of cs0) {
						for (const c1 of cs1) {
							dict.add(c0 + c1);
						}
					}
				}
			
				function addSolos(dict, head) {
					for (const h of head) {
						dict.add(h);
					}
				}
			}
			
			NS.ja.applyKerning         = apply;
			NS.ja.applyKerningToString = applyToString;
		}
		{
			/**
			 * Segmenter
			 *
			 * @author Takuto Yanagida
			 * @version 2022-05-27
			 */
			
			function apply(ts, opts = {}) {
				if (ts.length === 0) return;
			
				opts = Object.assign({
					styleSegment        : '',
					styleDisabled       : ':ncNoSegmentation',
					doDisableOnSelecting: true,
					properNouns         : [],
				}, opts);
				sortProperNouns(opts);
			
				for (const t of ts) {
					segmentElement(t, opts);
					if (opts['doDisableOnSelecting']) {
						const f = () => {
							removeSegment(t, opts);
							t.removeEventListener('selectstart', f);
						};
						t.addEventListener('selectstart', f);
					}
				}
			}
			
			function removeSegment(elm, opts) {
				const sty = opts.styleSegment;
				for (const s of [...elm.getElementsByTagName('span')]) {
					if ((sty.length === 0 && s.className === '') || hasClass(s, sty)) {
						const df = document.createDocumentFragment();
						for (const c of [...s.childNodes]) {
							df.appendChild(c);
						}
						s.parentNode.replaceChild(df, s);
					}
				}
			}
			
			function applyToString(str, opts = {}) {
				opts = Object.assign({
					styleSegment : '',
					styleDisabled: ':ncNoSegmentation',
					properNouns  : [],
				}, opts);
				sortProperNouns(opts);
			
				const [ts, ws] = getSegment(str, opts.properNouns);
				return createFragment(str, ts, ws, opts);
			}
			
			function sortProperNouns(opts) {
				const pns = opts['properNouns'].map(e => [...e]);
				pns.sort((a, b) => {
					return b.length - a.length;
				});
				opts['properNouns'] = pns;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function segmentElement(elm, opts) {
				for (const c of [...elm.childNodes]) {
					if (c.nodeType === 1) {  // ELEMENT_NODE
						if (!hasClass(c, opts.styleDisabled)) segmentElement(c, opts);
					} else if (c.nodeType === 3) {  // TEXT_NODE
						segmentTextNode(c, opts);
					}
				}
			}
			
			function segmentTextNode(tn, opts) {
				let str = tn.textContent;
				str = removeWhiteSpacesBetweenZenChars(str);
			
				const [ts, ws] = getSegment(str, opts.properNouns);
				const f = createFragment(str, ts, ws, opts);
				tn.parentNode.replaceChild(f, tn);
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			const IW = 'そうはいうものの,そればかりでなく,ありとあらゆる,いずれにしても,かけがえのない,そうしてみると,そうすることで,そうでないなら,そうではあるが,それにくわえて,それはさておき,どっちにしても,とはいうものの,なぜかというと,にもかかわらず,いいかえると,いずれにしろ,いずれにせよ,いってみれば,おもいきった,しかしながら,じつのところ,じつはいうと,そうしないと,そうではなく,そのためには,それどころか,それにしても,それによって,そればかりか,それはそうと,どちらにせよ,どっちにせよ,いろいろな,このように,さまざまな,さもないと,したがって,そういえば,そうしたら,そうすると,そうすれば,そうなると,そうなれば,そのかわり,それなのに,それゆえに,たくまざる,だとしたら,だとすると,だとすれば,ではあるが,というのは,というのも,というより,なぜならば,やすやすと,ようするに,ああいう,ああした,あたかも,あらゆる,あるいは,いかなる,いつかは,いっぱい,いろんな,いわゆる,おおきな,おかしな,おそらく,おなじく,おまけに,かえって,かくして,かわりに,くわえて,ぐんぐん,けれども,こういう,こうして,このため,しかるに,しばらく,すなわち,そういう,そうした,そのうえ,そのくせ,そのため,そもそも,それから,それから,それでは,それでも,それとも,それなら,それには,たいした,たいそう,たくさん,だけども,たとえば,たやすく,ちいさな,ちなみに,というか,どういう,とうてい,ときどき,ところが,どころか,ところで,となると,となれば,とにかく,とはいえ,ともあれ,とりわけ,ないしは,なかでも,なぜなら,なぜなら,なだたる,なにしろ,ならびに,はじめに,はずべき,はなはだ,ひいては,ひょんな,ふとした,ほかには,ほかにも,めっきり,もしくは,もっとも,あまり,あらぬ,ありし,あんな,いただ,いつか,いつも,いわば,および,かかる,かなり,きたる,きっと,けれど,ことに,こんな,さらに,しかし,しかも,じつは,じゃあ,すぐに,すぐに,すると,そこで,そして,そっと,それで,それに,そんな,だから,だけど,ただし,だって,たまに,つぎに,つまり,ですが,とある,どうか,ときに,とくに,とても,とんだ,どんな,なにせ,なのに,ならば,ほんの,まさか,または,むこう,むしろ,もっと,もっと,もっと,ものの,やはり,ゆえに,ようは,よって,ああ,あの,ある,かつ,かの,けど,こう,この,さて,さる,そう,その,だが,ただ,では,でも,どう,どの,なお,なぜ,のに,また,もし,よく,わが'.split(',');
			const AW = 'けれども,ところで,において,について,かしら,がてら,くらい,ぐらい,けれど,ってば,ながら,などの,なんぞ,ばかり,ものか,ものの,かい,から,かり,きり,こそ,さえ,しか,ずつ,だけ,だの,たり,つつ,では,ても,でも,とも,なぞ,など,なり,にて,には,ので,のに,のみ,ほど,まで,まま,もん,やら,より,か,が,さ,し,ぜ,ぞ,て,で,と,な,に,ね,の,は,ば,へ,も,や,よ,わ,を'.split(',');
			
			const AI1       = 'がおこな,のような,があり,がおき,ができ,がでて'.split(',');
			const PRE_KANJI = 'お,ご'.split(',');
			const PRE_NUM   = '第,約'.split(',');
			
			function getSegment(str, properNouns) {
				const ts = createCharTypeArray(str);
				const ws = Array(ts.length).fill(0);
			
				weightByCharTypes(ts, ws);
			
				const strA = [...str];
				if (properNouns.length) weightByPhrases(strA, ws, properNouns, -1);  // Divide
				weightByPhrases(strA, ws, IW, -1);  // Divide
				weightByPhrases(strA, ws, AW, 1);  // Concat
			
				weightByPhrases(strA, ws, AI1, -1, 1);  // Divide with offset
				weightByPhraseAndType(strA, ts, ws, PRE_KANJI, CLS_ALL,      'H', -1, 2);
				weightByPhraseAndType(strA, ts, ws, PRE_NUM,   CLS_WO_KANJI, 'N',  0, 2);
			
				return [ts, ws];
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			const CLS_WO_KANJI = 'SETIKNVO';
			const CLS_ALL      = 'SETIKHNVO';
			const CLS_ORIG     = 'NVO';
			
			const CHAR_PATTERNS = [
				['S', /[「『（［｛〈《【〔〖〘〚＜“]/u],
				['E', /[」』）］｝〉》】〕〗〙〛＞”]/u],
				['T', /[、，。．？！を：・]/u],
				['I', /[ぁ-んゝ]/u],
				['K', /[ァ-ヴーｱ-ﾝﾞｰ]/u],
				['H', /[々〆ヵヶ]|[\u4E00-\u9FFF]|[\u{20000}-\u{2A6DF}]/u],  // Special Characters, CJK Unified Ideographs, CJK Unified Ideographs Extension B
				['N', /[0-9０-９]/u],
				['V', /\s/u],
			];
			
			function createCharTypeArray(str) {
				const ts = [];
				for (const c of str) {
					ts.push(getCharType(c));
				}
				return ts;
			}
			
			function getCharType(c) {
				for (const [t, p] of CHAR_PATTERNS) {
					if (p.test(c)) return t;
				}
				return 'O';
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			const PAIRS = {
				'*S': -1, 'S*': 2,
				'*E': 2,
				'*T': 99, 'T*': -99,
				'*V': -1, 'V*': -1,
				'II': 1, 'KK': 1, 'HH': 1,  'NN': 1, 'OO': 1, 'TT': 1,
				'HI': 1,
				'NH': 2, 'NK': 1, 'NI': 1,
				'ON': 1, 'NO': 1,
			};
			
			function weightByCharTypes(ts, ws) {
				for (let i = 1; i < ts.length; i += 1) {
					const t0 = ts[i - 1];
					const t1 = ts[i];
					ws[i] += (PAIRS[t0 + t1] ?? 0) + (PAIRS['*' + t1] ?? 0) + (PAIRS[t0 + '*'] ?? 0);
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function divideByPhrases(strA, ws, phrases) {
				for (const ph of phrases) {
					const phA = [...ph];
					const phL = phA.length;
			
					for (let bgn = 0;;) {
						const idx0 = indexOfArray(strA, phA, bgn);
						if (idx0 === -1) break;
						const idx1 = idx0 + phL;
			
						ws[idx0] -= phL;
						for (let i = 1; i < phL; i += 1) ws[idx0 + i] += phL;
						bgn = idx1;
					}
				}
			}
			
			function divideByCombinedPhrases(strA, ws, phrases, al) {
				for (const ph of phrases) {
					const phA = [...ph];
					const phL = phA.length;
			
					for (let bgn = 0;;) {
						const idx0 = indexOfArray(strA, phA, bgn);
						if (idx0 === -1) break;
						const idx1 = idx0 + phL;
			
						ws[idx0 + al] -= phL - al;
						for (let i = 1; i < phL - al; i += 1) ws[idx0 + al + i] += phL - al;
						bgn = idx1;
					}
				}
			}
			
			function concatByPhrases(strA, ws, phrases) {
				for (const ph of phrases) {
					const phA = [...ph];
					const phL = phA.length;
			
					for (let bgn = 0; ;) {
						const idx0 = indexOfArray(strA, phA, bgn);
						if (idx0 === -1) break;
						const idx1 = idx0 + phL;
			
						ws[idx0] += phL;
						for (let i = 1; i < phL; i += 1) ws[idx0 + i] += phL;
						bgn = idx1;
					}
				}
			}
			
			function weightByPhrases(strA, ws, phrases, factor, offset = 0) {
				for (const ph of phrases) {
					const phA = [...ph];
					const phL = phA.length;
			
					for (let bgn = 0;;) {
						const idx0 = indexOfArray(strA, phA, bgn);
						if (idx0 === -1) break;
						const idx1 = idx0 + phL;
			
						ws[idx0 + offset] += (phL - offset) * factor;
						for (let i = 1; i < phL - offset; i += 1) {
							ws[idx0 + offset + i] += (phL - offset);
						}
						bgn = idx1;
					}
				}
			}
			
			function weightByPhraseAndType(strA, ts, ws, phrases, prevCts, nextCts, prevW, nextW) {
				const tsL = ts.length;
			
				for (const ph of phrases) {
					const phA = [...ph];
					const phL = phA.length;
			
					for (let bgn = 0; ;) {
						const idx0 = indexOfArray(strA, phA, bgn);
						if (idx0 === -1) break;
						const idx1 = idx0 + phL;
			
						if (
							(idx0 === 0   || (idx0 !== 0 && prevCts.includes(ts[idx0 - 1]))) &&
							(idx1 === tsL || (idx1 < tsL && nextCts.includes(ts[idx1])))
						) {
							ws[idx0] += prevW;
							if (idx1 < ws.length) ws[idx1] += nextW;
							for (let i = 1; i < phL; i += 1) ws[idx0 + i] += phL;
						}
						bgn = idx1;
					}
				}
			}
			
			function indexOfArray(array, searchElement, fromIndex = 0) {
				if (array === null || array === undefined) {
					return -1;
				}
				if (array.length === 0) {
					return -1;
				}
				for (let i = fromIndex; i < array.length - searchElement.length + 1; i += 1) {
					let match = true;
			
					for (let j = 0; j < searchElement.length; j += 1) {
						if (array[i + j] !== searchElement[j]) {
							match = false;
							break;
						}
					}
					if (match) {
						return i;
					}
				}
				return -1;
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function createFragment(str, ts, ws, opts) {
				const df = document.createDocumentFragment();
				let temp = '';
				let bgn  = 0;
			
				let idx = 0;
				for (const c of str) {
					if (ws[idx] <= 0) {
						const isOrig = isOriginalCharPhrase(ts, bgn, idx);
						appendPhrase(df, temp, isOrig, opts.styleSegment);
						temp = '';
						bgn  = idx;
					}
					temp += c;
					idx  += 1;
				}
				if (temp.length) {
					const isOrig = isOriginalCharPhrase(ts, bgn, ts.length);
					appendPhrase(df, temp, isOrig, opts.styleSegment);
				}
				return df;
			}
			
			function appendPhrase(df, str, isOrig, style) {
				if (isOrig) {
					df.appendChild(document.createTextNode(str));
				} else {
					const e = document.createElement('span');
					e.appendChild(document.createTextNode(str));
					if (style.length) setClass(e, style);
					df.appendChild(e);
				}
			}
			
			function isOriginalCharPhrase(ts, bgn, end) {
				for (let i = bgn; i < end; i += 1) {
					const t = ts[i];
					if (!CLS_ORIG.includes(t)) {
						return false;
					}
				}
				return true;
			}
			
			NS.ja.applySegmenter         = apply;
			NS.ja.applySegmenterToString = applyToString;
		}
		/**
		 * Common Functions
		 *
		 * @author Takuto Yanagida
		 * @version 2021-11-03
		 */
		
		function removeHeadWhiteSpaces(str) {
			const mzs = str.match(/^[\n\r\t ]*(\u3000*)/);
			const zs = (mzs && 1 < mzs.length) ? mzs[1] : '';
			return zs + str.replace(/^\s+/g, '');  // Trim left
		}
		
		function removeTailWhiteSpaces(str) {
			return str.replace(/\s+$/g, '');  // Trim right
		}
		
		function removeWhiteSpacesBetweenZenChars(str) {
			// White space character class excluding \u3000
			// [ \f\n\r\t\v​\u00a0​\u180e\u2000​-\u200a​\u2028\u2029\u202f\u205f​\ufeff]
			return str.replace(/([^\x01-\x7E\xA1-\xDF]+)([\t\n]+|[ \f\n\r\t\v\u00a0\u180e\u2000-\u200a\u2028\u2029\u202f\u205f\ufeff]{2})([^\x01-\x7E\xA1-\xDF]+)/g, (match, g1, d, g2) => g1 + g2);
		}
		
	}

	// Link --------------------------------------------------------------------
	NS['link'] = {};
	{
		{
			/**
			 *
			 * Type
			 *
			 * @author Takuto Yanagida
			 * @version 2022-10-05
			 *
			 */
			
			
			function apply(as, opts = {}) {
				opts = Object.assign({
					styleLinkImage     : ':ncLinkImage',
					styleLinkSimple    : ':ncLinkSimple',
					styleLinkAnchor    : ':ncLinkAnchor',
					styleLinkExternal  : ':ncLinkExternal',
					styleLinkFile      : ':ncLinkFile',
					styleLinkToImage   : ':ncLinkToImage',
					allowedClasses     : ALLOWED_CLASSES,
					fileExtensionTable : FILE_EXT_TABLE,
					imageExtensionTable: IMG_EXT_TABLE,
					isUrlExternal      : isUrlExternal,
					observedSelector   : null,
				}, opts);
			
				for (const a of as) {
					addClass(a, a.getAttribute('href'), opts);
				}
				initializeObservation(opts);
			}
			
			function applyByUrl(as, opts = {}) {
				opts = Object.assign({
					styleLinkAnchor    : ':ncLinkAnchor',
					styleLinkExternal  : ':ncLinkExternal',
					styleLinkFile      : ':ncLinkFile',
					styleLinkToImage   : ':ncLinkToImage',
					fileExtensionTable : FILE_EXT_TABLE,
					imageExtensionTable: IMG_EXT_TABLE,
					isUrlExternal      : isUrlExternal,
					observedSelector   : null,
				}, opts);
			
				for (const a of as) {
					addClassByUrl(a, a.getAttribute('href'), opts);
				}
				initializeObservation(opts);
			}
			
			const ALLOWED_CLASSES = [
				'alignleft',
				'aligncenter',
				'alignright',
				'size-thumbnail',
				'size-small',
				'size-medium-small',  // For backward compatibility
				'size-medium',
				'size-medium-large',
				'size-medium_large',
				'size-large',
				'size-x-large',
				'size-xx-large',
				'size-xxx-large',
				'size-full'
			];
			
			const FILE_EXT_TABLE = {
				doc : 'doc',
				docx: 'doc',
				xls : 'xls',
				xlsx: 'xls',
				ppt : 'ppt',
				pptx: 'ppt',
				pdf : 'pdf',
			};
			
			const IMG_EXT_TABLE = {
				jpeg: 'jpg',
				jpg : 'jpg',
				png : 'png',
				gif : 'gif',
			};
			
			
			// -------------------------------------------------------------------------
			
			
			const observing = [];
			
			function initializeObservation(opts) {
				const sel = opts['observedSelector'];
				if (sel && !observing.includes(sel)) {
					observing.push(sel);
					const os = document.querySelectorAll(sel);
					observeAddition(os, o => addClassByUrl(o, o.getAttribute('href'), opts));
				}
			}
			
			function addClass(a, url, opts) {
				if (isImageLink(a, opts)) {
					setClass(a, opts.styleLinkImage);
					const ti = opts.imageExtensionTable[getFileExtension(url)] ?? null;
					if (ti) {
						setClass(a, opts.styleLinkToImage);
						setClass(a, opts.styleLinkToImage, true, ti);
					}
				} else {
					if (isEmptyLink(a)) {
						addClassByUrl(a, url, opts);
					} else if (isSimpleLink(a)) {
						setClass(a, opts.styleLinkSimple);
						if (isSimpleUrlLink(a, url)) {
							setClass(a, opts.styleLinkSimple, true, 'url');
						}
						addClassByUrl(a, url, opts);
					}
				}
			}
			
			function isImageLink(a, opts) {
				if (a.className) {
					for (const c of a.className.split(' ')) {
						if (!opts.allowedClasses.includes(c)) return false;
					}
				}
				let ok = false;
				for (const c of a.childNodes) {
					if (c.nodeType === 1) {  // ELEMENT_NODE
						if (!ok && c.tagName === 'IMG') {
							ok = true;
						} else {
							ok = false;
							break;
						}
					}
				}
				return ok;
			}
			
			function isSimpleLink(a) {
				if (a.className) return false;
				const cs = a.childNodes;
				if (cs.length === 0) return false;
				for (const c of cs) {
					if (c.className) return false;
					if (c.nodeType === 1) {  // ELEMENT_NODE
						if (c.tagName !== 'BR' && !getComputedStyle(c).display.includes('inline')) {
							return false;
						}
					}
				}
				return true;
			}
			
			function isEmptyLink(a) {
				return !a.className && a.childNodes.length === 0;
			}
			
			function isSimpleUrlLink(a, url) {
				return url !== null && url !== '' && a.childNodes.length && a.innerHTML.trim() === url;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function addClassByUrl(a, url, opts) {
				const outIsUp = [false];
				if (isUrlAnchor(url, a, outIsUp)) {
					setClass(a, opts.styleLinkAnchor, true, outIsUp[0] ? 'up' : '');
				} else if (opts.isUrlExternal(url)) {
					setClass(a, opts.styleLinkExternal);
				}
				const ex = getFileExtension(url);
				const tf = opts.fileExtensionTable[ex]  ?? null;
				const ti = opts.imageExtensionTable[ex] ?? null;
				if (tf) {
					setClass(a, opts.styleLinkFile);
					setClass(a, opts.styleLinkFile, true, tf);
				}
				if (ti) {
					setClass(a, opts.styleLinkToImage);
					setClass(a, opts.styleLinkToImage, true, ti);
				}
			}
			
			function isUrlExternal(url) {
				if (url !== null && url !== '') {
					if (!url.startsWith(`${location.protocol}//${location.host}`)) {
						if (url.match(/^https?:\/\//) || url.match(/^\/\//)) {
							return true;
						}
					}
				}
				return false;
			}
			
			function getFileExtension(url) {
				if (url) {
					const b0 = url.indexOf('//');
					if (b0 !== -1) {
						const b1 = url.indexOf('/', b0 + 2);
						url = (b1 !== -1) ? url.substring(b1 + 1) : '';
					}
					const e0 = url.indexOf('?');
					if (e0 !== -1) url = url.substring(0, e0);
					const e1 = url.indexOf('#');
					if (e1 !== -1) url = url.substring(0, e1);
			
					if (!url.endsWith('/')) {
						const last = url.split('/').pop();
			
						const i = last.lastIndexOf('.');
						if (i !== -1) {
							return last.substring(i + 1).toLowerCase();
						}
					}
				}
				return null;
			}
			
			NS.link.applyType      = apply;
			NS.link.applyTypeByUrl = applyByUrl;

			NS.link.isImageLink = isImageLink;
		}
		{
			/**
			 *
			 * Smooth Scroll
			 *
			 * @author Takuto Yanagida
			 * @version 2023-07-18
			 *
			 */
			
			
			const DURATION = 400;
			
			let isScrolling = false;
			const anchorWithListener = new Set();
			
			function apply(as, opts = {}) {
				opts = Object.assign({
					duration        : DURATION,
					observedSelector: null,
				}, opts);
			
				for (const a of as) {
					addListener(a, opts);
				}
				document.addEventListener('wheel', () => { isScrolling = false; });
			
				if (opts['observedSelector']) {
					const os = document.querySelectorAll(opts['observedSelector']);
					observeAddition(os, o => addListener(o, opts));
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function addListener(a, opts) {
				if (!anchorWithListener.has(a)) {
					function onClick(e) { doClick(e, opts); }
					if (a.href === '#' || a.href === '#top' || isUrlAnchor(a.href)) {
						a.addEventListener('click', onClick);
						anchorWithListener.add(a);
					}
				}
			}
			
			function doClick(e, opts) {
				if (e.button !== 0 || e.ctrlKey || e.shiftKey || e.altKey || e.metaKey) return;
				const href = e.currentTarget.getAttribute('href');
				const idx  = href.indexOf('#');
				if (idx !== -1) {
					smoothScrollToHash(e, href.substring(idx), opts.duration);
				}
			}
			
			function smoothScrollToHash(e, hash, duration = DURATION) {
				const top = (hash === null || hash === '' || hash === '#' || hash === '#top');
				const tar = top ? document.documentElement : document.getElementById(hash.substring(1));
				if (tar && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					e.stopPropagation();
					e.preventDefault();
			
					smoothScrollToElement(tar, duration);
					if (hash !== window.location.hash) {
						history.pushState(null, null, (hash === '#top' ? '' : hash));
					}
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function smoothScrollToElement(tar, duration = DURATION, focus = true) {
				const start = window.scrollY;
				let posY = getScrollPos(tar);
				let wh   = document.documentElement.offsetHeight;
			
				let timeStart;
				isScrolling = true;
				requestAnimationFrame((time) => { timeStart = time; loop(time); });
			
				function loop(time) {
					if (!isScrolling) return;
					if (wh !== document.documentElement.offsetHeight) {  // For delay loading
						posY = getScrollPos(tar);
						wh   = document.documentElement.offsetHeight;
					}
					window.scrollTo(0, easing(time - timeStart, start, posY, duration));
					if (time - timeStart < duration) {
						requestAnimationFrame(loop)
					} else {
						window.scrollTo(0, getScrollPos(tar));
						setTimeout(() => window.scrollTo(0, getScrollPos(tar)), 50);
						if (focus && tar && tar !== document.documentElement) {
							tar.focus();
						}
						isScrolling = false;
					}
				}
			}
			
			function getScrollPos(tar) {
				const spt = parseInt(getComputedStyle(document.documentElement).scrollPaddingTop);
				return tar.getBoundingClientRect().top + window.scrollY - spt;
			}
			
			function easing(t, b, c, d) {
				t /= d / 2;
				if (t < 1) return (c - b) / 2 * t * t + b;
				t--;
				return -(c - b) / 2 * (t * (t - 2) - 1) + b;
			}
			
			NS.link.applySmooth = apply;

			NS.smoothScrollToElement = smoothScrollToElement;
		}
		/**
		 *
		 * Common Functions
		 *
		 * @author Takuto Yanagida
		 * @version 2021-12-27
		 *
		 */
		
		
		function isUrlAnchor(url, a = null, outIsUp = null) {
			if (url !== null && url !== '') {
				const p = url.indexOf('#');
				if (p !== -1) {
					const id = url.substring(p + 1);
					if (id.length) {
						const t = document.getElementById(id);
						if (t !== null) {
							if (
								p === 0 ||
								url.substring(0, p) === location.href.replace(location.hash ? location.hash : '#', '')
							) {
								if (a && outIsUp) {
									const from = a.getBoundingClientRect().top;
									const to   = t.getBoundingClientRect().top;
									if (to < from) outIsUp[0] = true;
								}
								return true;
							}
						}
					}
				}
			}
			return false;
		}
		
		function observeAddition(os, fn) {
			if (!os.length) return;
			const mo = new MutationObserver(rs => {
				for (const r of rs) {
					for (const n of r.addedNodes) {
						if (n.nodeType === 1 && n.tagName === 'A') {
							fn(n);
						}
					}
				}
			});
			for (const o of os) {
				mo.observe(o, {
					childList: true,
					subtree  : true,
				});
			}
		}
		
	}

	// List --------------------------------------------------------------------
	NS['list'] = {};
	{
		/**
		 * Custom
		 *
		 * @author Takuto Yanagida
		 * @version 2022-08-04
		 */
		
		function apply(uls, opts = {}) {
			opts = Object.assign({
				styleList   : ':ncList',
				customType  : [],
				doClearStyle: true,
			}, opts);
		
			for (const ul of uls) {
				setStyle(ul, opts);
			}
		}
		
		function setStyle(t, opts) {
			const type = t.style.listStyleType;
			if (type !== '' && type !== 'none' && opts.customType.includes(type)) {
				if (opts.doClearStyle) {
					const re = new RegExp('list-style\\s*:\\s*' + type + '\\s*;?', 'gi');
					if (t.getAttribute('style').match(re)) {
						t.removeAttribute('style');
					} else {
						t.style.listStyleType = '';
					}
				}
				setClass(t, opts.styleList, true, type);
			}
		}
		
		NS.list.applyCustom = apply;
	}

	// Scroll Effect -----------------------------------------------------------
	NS['scroll'] = {};
	{
		/**
		 * Scroll Effect
		 *
		 * @author Takuto Yanagida
		 * @version 2023-07-27
		 */
		
		function apply(ts, opts = {}) {
			if (ts.length === 0) return;
		
			opts = Object.assign({
				styleEffect: ':ncScrollEffect',
				threshold  : 0.5,
			}, opts);
		
			onIntersect(doIntersect, ts, opts['threshold'], '* 10000% 0px 10000%');
			function doIntersect(vs) {
				for (let i = 0; i < ts.length; i += 1) {
					if (vs[i]) setClass(ts[i], opts['styleEffect'], true, 'visible');
				}
			}
		
			window.addEventListener('beforeprint', () => {
				for (const c of ts) {
					setClass(c, opts['styleEffect'], true, 'visible');
				}
			});
		}
		
		NS.scroll.apply = apply;
	}

	// Tab ---------------------------------------------------------------------
	NS['tab'] = {};
	{
		{
			/**
			 * Scroll
			 *
			 * @author Takuto Yanagida
			 * @version 2023-01-16
			 */
			
			function apply(cs, opts = {}) {
				if (cs.length === 0) return;
			
				opts = Object.assign({
					styleBar    : ':ncTabBar',
					styleCurrent: ':ncCurrent',
					styleActive : ':ncActive',
					hashPrefix  : 'tsc:',
				}, opts);
				const is = [];
				for (let i = 0; i < cs.length; i += 1) {
					const inst = create(cs[i], i + 1, opts);
					if (inst) is.push(inst);
				}
				window.addEventListener('hashchange', () => is.forEach(onHashChanged));
			}
			
			function onHashChanged(inst) {
				const tar = getCurrentByHash(inst, location.hash);
				inst.active = tar;
				setTimeout(() => update(inst), 10);
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function create(cont, cid, opts) {
				const inst = {
					opts,
					vs    : null,
					uls   : [],
					active: null,
				}
				const hs = extractHeadings(cont, cid, opts.hashPrefix);
				if (hs.length === 0) return false;
			
				const noHash = location.hash.length <= 1;
				const bars   = [];
				hs.forEach((h, idx) => {
					const bar = createBar(hs, h, opts, noHash && idx === 0);
					cont.insertBefore(bar.ul, h.elm);
					bars.push(bar);
					inst.uls.push(bar.ul);
				});
				assignEvent(inst, bars);
			
				inst.active = getCurrentByHash(inst, location.hash);
				setTimeout(() => update(inst), 100);  // For avoiding unnecessary update
				return inst;
			}
			
			function getCurrentByHash(inst, hash) {
				const id = hash.replace('#', '');
				if (id !== '') {
					const tar = document.getElementById(id);
					if (tar && inst.uls.indexOf(tar) !== 0) {
						return tar;
					}
				}
				return null;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function extractHeadings(cont, cid, prefix) {
				const fh = getFirstHeading(cont);
				if (!fh) return [];
				const tn = fh.tagName;
				const hs = [];
			
				for (const elm of [...cont.children]) {
					if (elm.tagName === tn) {
						const id = `${prefix}${cid}-${hs.length + 1}`;
						hs.push({ elm, id });
					}
				}
				return hs;
			}
			
			function createBar(hs, curH, opts, activate) {
				const ul = document.createElement('ul');
				ul.id = curH.id;
				ul.className = '';  // for Dummy
				setClass(ul, opts.styleBar);
				if (activate) setClass(ul, opts.styleActive);
				const as = [];
			
				for (const h of hs) {
					const a = createAnchor(h);
					const li = document.createElement('li');
					if (h === curH) {
						setClass(a, opts.styleCurrent);
						setClass(li, opts.styleCurrent);
					}
					li.appendChild(a);
					ul.appendChild(li);
					as.push(a);
				}
				return { ul, as };
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function assignEvent(inst, bars) {
				for (const bar of bars) {
					bar.as.forEach((a, i) => {
						a.addEventListener('click', () => onClick(inst, bar.ul, bars[i].ul));
					});
				}
				onIntersect((vs) => {
					inst.vs = vs;
					update(inst);
				}, inst.uls, 0);
			}
			
			function onClick(inst, from, to) {
				if (to !== from) {
					const fromY = from.getBoundingClientRect().top;
					const toR   = to.getBoundingClientRect();
					if (toR.y < fromY && 0 <= toR.y && toR.y + toR.height < window.innerHeight) {
						setTimeout(() => window.scrollBy({ top: toR.y - fromY, }), 200);
					}
				}
			
				inst.active = to;
				setTimeout(() => {
					if (inst.active) {
						const y = inst.active.getBoundingClientRect().top;
						inst.active = null;
						if (window.innerHeight < y) update(inst);
					}
				}, 1000);
			}
			
			function update(inst) {
				const tar = inst.active ? inst.active : getFirstVisible(inst);
				for (const ul of inst.uls) {
					setClass(ul, inst.opts.styleActive, ul === tar);
				}
			}
			
			function getFirstVisible(inst) {
				if (!inst.vs) return null;
				return inst.uls.find((ul, i) => inst.vs[i]);
			}
			
			NS.tab.applyScroll = apply;
		}
		{
			/**
			 * Stack
			 *
			 * @author Takuto Yanagida
			 * @version 2023-01-14
			 */
			
			function apply(cs, opts = {}) {
				if (cs.length === 0) return;
			
				opts = Object.assign({
					styleBar        : ':ncTabBar',
					styleCurrent    : ':ncCurrent',
					styleActive     : ':ncActive',
					styleVertical   : ':ncVertical',
					hashPrefix      : 'tst:',
					maxHeightRate   : 0.8,
					maxVerticalWidth: 599.5,
					doRemoveHeading : false,
					doUseHeadingId  : false,
					doUseBarBelow   : true,
				}, opts);
				if (!opts.doRemoveHeading && opts.doUseHeadingId) {
					opts.doUseHeadingId = false;
					console.log('nacss.tab.stack: \'opts.doRemoveHeading\' must be true when \'opts.doUseHeadingId\' is true');
				}
				const is = [];
				for (let i = 0; i < cs.length; i += 1) {
					const inst = create(cs[i], i + 1, opts);
					if (inst) is.push(inst);
				}
				onResize(() => is.forEach(resize), true);
				window.addEventListener('hashchange', () => is.forEach(onHashChanged) );
			
				setTimeout(() => {
					const id = location.hash.replace('#', '');
					if (id !== '') {
						const tar = document.getElementById(id);
						if (tar) tar.scrollIntoView({ behavior: 'smooth' });
					}
				}, 10);
			}
			
			function onHashChanged(inst) {
				let idx = getCurrentByHash(inst, location.hash);
				if (idx === null) idx = getAnchorPage(inst, location.hash);
				if (idx !== null) setTimeout(() => update(inst, idx), 10);
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function create(cont, cid, opts) {
				const inst = {
					opts,
					cont,
					ps    : null,
					bars  : [],
					curIdx: 0,
				};
				const [hs, ps] = extractHeadingsAndPages(cont, cid, opts);
				if (hs.length === 0) return false;
				inst.ps = ps;
			
				const bar0 = createBar(hs, opts);
				const bar1 = createBar(hs, opts);
				inst.bars.push(bar0, bar1);
			
				cont.insertBefore(bar0.ul, cont.firstChild);
				for (const p of ps) cont.appendChild(p);
				cont.appendChild(bar1.ul);
			
				assignEvent(inst);
			
				const h = location.hash;
				let idx = getCurrentByHash(inst, h);
				if (idx === null) idx = getAnchorPage(inst, h);
				if (idx === null) idx = isVertical(inst) ? -1 : 0;
				setTimeout(() => update(inst, idx), 10);
				return inst;
			}
			
			function getCurrentByHash(inst, hash) {
				if (hash.indexOf('#') === -1) return null;
				const re = new RegExp(hash + '$', 'g');
				const as = inst.bars[0].as;
				for (let i = 0; i < as.length; i += 1) {
					if (as[i].href.match(re)) return i;
				}
				return null;
			}
			
			function getAnchorPage(inst, hash) {
				const id = hash.replace('#', '');
				if (id !== '') {
					const tar = document.getElementById(id);
					if (tar) {
						const idx = inst.ps.findIndex(p => p.contains(tar));
						if (idx !== -1) return idx;
					}
				}
				return null;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function extractHeadingsAndPages(cont, cid, opts) {
				const fh = getFirstHeading(cont);
				if (!fh) return [];
				const tn = fh.tagName;
				const hs = [];
				const ps = [];
				let curP = null;
			
				for (const elm of [...cont.children]) {
					if (elm.tagName === tn) {
						const id = (opts.doUseHeadingId && elm.id) ? elm.id : `${opts.hashPrefix}${cid}-${hs.length + 1}`;
						hs.push({ elm, id });
			
						if (curP) ps.push(curP);
						curP = document.createElement('div');
						if (opts.doRemoveHeading) {
							cont.removeChild(elm);
						} else {
							curP.appendChild(elm);
						}
					} else {
						if (curP) curP.appendChild(elm);
					}
				}
				if (curP) ps.push(curP);
				return [hs, ps];
			}
			
			function createBar(hs, opts) {
				const ul = document.createElement('ul');
				ul.className = '';  // for Dummy
				setClass(ul, opts.styleBar);
				const as = [];
			
				for (const h of hs) {
					const a = createAnchor(h);
					const li = document.createElement('li');
					li.appendChild(a);
					ul.appendChild(li);
					as.push(a);
				}
				return { ul, as };
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function assignEvent(inst) {
				for (const bar of inst.bars) {
					bar.as.forEach((a, i) => {
						a.addEventListener('click', (e) => onClick(e, inst, i));
					});
				}
			}
			
			function onClick(e, inst, idx) {
				e.preventDefault();
				if (getComputedStyle(e.target.parentElement).pointerEvents === 'none') return;
				let url = e.currentTarget.href;
				if (inst.curIdx === idx) {
					idx = -1;
					url = url.replace(/#.*$/, '');
				}
				history.pushState({}, null, url);
				update(inst, idx);
				scrollToTab(inst);
			}
			
			function isVertical(inst) {
				return hasClass(inst.cont, inst.opts.styleVertical);
			}
			
			function scrollToTab(inst) {
				if (inst.curIdx === -1) return;
				setTimeout(() => {
					const [{ ul: ul0 }, { ul: ul1 }] = inst.bars;
					const r0 = ul0.getBoundingClientRect();
					if (0 <= r0.top && r0.top <= window.innerHeight && 0 <= r0.bottom && r0.bottom <= window.innerHeight) {
						return;
					}
					const r1 = ul1.getBoundingClientRect();
					if (isVertical(inst) || (r1.top < 0 || window.innerHeight < r1.bottom)) {
						inst.cont.scrollIntoView({ behavior: 'smooth' });
					}
				}, 10);
			}
			
			function update(inst, idx) {
				const ps = inst.ps;
				const [{ as: a0 }, { as: a1 }] = inst.bars;
			
				for (let i = 0; i < ps.length; i += 1) {
					setClass(a0[i], inst.opts.styleCurrent, i === idx);
					setClass(a1[i], inst.opts.styleCurrent, i === idx);
					setClass(a0[i].parentElement, inst.opts.styleCurrent, i === idx);
					setClass(a1[i].parentElement, inst.opts.styleCurrent, i === idx);
					setClass(ps[i], inst.opts.styleCurrent, i === idx);
				}
				inst.curIdx = idx;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function resize(inst) {
				const cont = inst.cont;
				setClass(cont, inst.opts.styleVertical, window.innerWidth <= inst.opts.maxVerticalWidth);
			
				if (isVertical(inst)) {
					cont.style.minHeight = '';
					if (!inst.opts.doUseBarBelow) {
						inst.bars[1].ul.style.display = '';
					}
				} else {
					const minH = getMinHeight(inst);
					const h = (minH < window.innerHeight * inst.opts.maxHeightRate) ? `${minH}px` : '';
					cont.style.minHeight = h;
					if (!inst.opts.doUseBarBelow) {
						inst.bars[1].ul.style.display = 'none';
					}
					if (inst.curIdx === -1) {
						update(inst, 0);
					}
				}
			}
			
			function getMinHeight(inst) {
				const [{ ul: ul0 }, { ul: ul1 }] = inst.bars;
			
				let marginBtm = parseInt(getComputedStyle(ul0).marginBottom);
				let marginTop = parseInt(getComputedStyle(ul1).marginTop);
				let height = 0;
			
				for (const p of inst.ps) {
					const ps = getComputedStyle(p);
					const mt = parseInt(ps.marginTop);
					const mb = parseInt(ps.marginBottom);
					const h  = p.getBoundingClientRect().height;
			
					marginBtm = Math.max(marginBtm, mt);
					marginTop = Math.max(marginTop, mb);
					height    = Math.max(height, h);
				}
				return ul0.offsetHeight + ul1.offsetHeight + marginBtm + marginTop + height;
			}
			
			NS.tab.applyStack = apply;
		}
		/**
		 * Common Functions
		 *
		 * @author Takuto Yanagida
		 * @version 2022-01-07
		 */
		
		function getFirstHeading(container) {
			const cs = container.children;
			for (let i = 0; i < cs.length; i += 1) {
				if (/^H[1-6]$/.test(cs[i].tagName)) return cs[i];
			}
			return null;
		}
		
		function createAnchor(h) {
			const a = document.createElement('a');
			a.href  = '#' + h.id;
			a.title = h.elm.innerText;
			const t = h.elm.title ? h.elm.title : h.elm.innerHTML;
		
			a.innerHTML = t;
			a.querySelectorAll('small').forEach(e => e.remove());
			if (a.innerText === '') {
				a.innerHTML = t;
			}
			spanning(a);
			return a;
		}
		
		function spanning(e) {
			for (const c of [...e.children]) {
				if (c.tagName === 'A' || c.tagName === 'SMALL') {
					const s = document.createElement('span');
					s.innerHTML = c.innerHTML;
					e.replaceChild(s, c);
					spanning(s);
				} else {
					spanning(c);
				}
			}
		}
		
	}

	// Table -------------------------------------------------------------------
	NS['table'] = {};
	{
		{
			/**
			 * Neat Width
			 *
			 * @author Takuto Yanagida
			 * @version 2023-01-17
			 */
			
			function apply(tabs, opts = {}) {
				if (tabs.length === 0) return;
			
				const lt = tabs[tabs.length - 1];
				const cm = Object.assign({
					fullWidthRate   : 0.95,
					cellMinWidth    : 80,
					cellMinAspect   : 2 / 3,  // width / height
					cellMinLength   : 8,
					maxRowSize      : 200,
					maxBorderWidth  : 2,
					before          : null,  // function (table) { ...; return delay; }
					after           : null,  // function (table) { ... }
					styleNeat       : ':ncTableNeat',
					styleFull       : ':ncTableFull',
					styleScrollRight: ':ncScrollRight',
					styleScrollLeft : ':ncScrollLeft',
				}, opts, getCommonMetrics(lt));
			
				cm.padH += cm.maxBorderWidth * 2;
				cm.padV += cm.maxBorderWidth * 2;
				cm.dcTd = makeDummyCell(lt, 'td');
				cm.dcTh = makeDummyCell(lt, 'th');
			
				const tarTabs = [], noTarTabs = [];
				for (const t of tabs) {
					if (isTarget(t, cm)) tarTabs.push(t);
					else noTarTabs.push(t);
				}
				cm.gcCount = tarTabs.length;
			
				for (const t of tarTabs) {
					const delay = (cm.before) ? (cm.before(t) ?? 0) : false;
					st(() => {
						adjustWidth(t, cm);
						setClass(t, cm.styleNeat);
						if (cm.after) cm.after(t);
						if (--cm.gcCount === 0) removeDummyCell(lt, cm);
					}, delay);
				}
				if (cm.fullWidthRate) {
					for (const t of noTarTabs) {
						const pw = t.parentElement.clientWidth;
						if (pw * cm.fullWidthRate < t.clientWidth) setClass(t, cm.styleFull);
					}
				}
				function st(fn, d) { (d === false) ? fn() : setTimeout(fn, d); }
				initScroll(tarTabs, cm);
			}
			
			function getCommonMetrics(tab) {
				const td = tab.getElementsByTagName('td')[0];
				const s = getComputedStyle(td);
				const padH  = parseFloat(s.paddingLeft) + parseFloat(s.paddingRight);
				const padV  = parseFloat(s.paddingTop) + parseFloat(s.paddingBottom);
				const [charW, lineH] = getTextSize(td);
				return { padH, padV, charW, lineH };
			}
			
			function getTextSize(elm) {
				const d = document.createElement(elm.nodeName);
				d.setAttribute('style', `position:fixed;margin:0;padding:0;font-family:${elm.style.fontFamily || 'inherit'};font-size:${elm.style.fontSize || 'inherit'};`);
				d.innerHTML = '\u3000';  // Full width space
				elm.parentNode.appendChild(d);
				const w = d.clientWidth;
				const h = d.clientHeight;
				d.parentNode.removeChild(d);
				return [w, h];
			}
			
			function makeDummyCell(t, tagName) {
				const d = document.createElement(tagName);
				d.setAttribute('style', `position:fixed;display:inline-block;visibility:hidden;white-space:nowrap;`);
				return t.appendChild(d);
			}
			
			function removeDummyCell(lt, cMat) {
				lt.removeChild(cMat.dcTd);
				lt.removeChild(cMat.dcTh);
			}
			
			function isTarget(tab, cMet) {
				if (tab.rows.length === 0) return false;
				if (cMet.maxRowSize < tab.rows.length) return false;
			
				const { cellMinWidth, cellMinAspect } = cMet;
				for (const tr of tab.rows) {
					if (!tr.hasChildNodes()) continue;
					for (const n of tr.childNodes) {
						const tn = n.tagName;
						if (tn !== 'TD' && tn !== 'TH') continue;
						if (1 < parseInt(n.getAttribute('colSpan'), 10)) continue;
						if (1 < parseInt(n.getAttribute('rowSpan'), 10)) continue;
						const cw = n.clientWidth;
						const ch = n.clientHeight;
						if (cw < cellMinWidth || cw / ch < cellMinAspect) return true;
					}
				}
				return false;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function initScroll(tabs, cMet) {
				const rob = new ResizeObserver(oes => {
					for (const oe of oes) {
						onResize(oe.target);
						onScroll(oe.target, cMet);
					}
				});
				for (const t of tabs) {
					rob.observe(t);
					t.addEventListener('scroll', throttle(() => { onScroll(t, cMet); }));
				}
			}
			
			function onResize(tab) {
				const th = tab.clientHeight;
				const ch = tab.caption?.clientHeight ?? 0;
				tab.style.setProperty('--nc-height', `${th - ch}px`)
			}
			
			function onScroll(tab, cMet) {
				if (tab.scrollWidth - tab.clientWidth > 2) {  // for avoiding needless scrolling
					const r = tab.scrollLeft / (tab.scrollWidth - tab.clientWidth);
					setClass(tab, cMet.styleScrollRight, r < 0.95);
					setClass(tab, cMet.styleScrollLeft, 0.05 < r);
				} else {
					setClass(tab, cMet.styleScrollRight, false);
					setClass(tab, cMet.styleScrollLeft, false);
				}
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function adjustWidth(tab, cMet) {
				tab.removeAttribute('width');
				if (tab.style.width) tab.style.width = null;
				if (tab.style.height) tab.style.height = null;
			
				const grid  = makeCellGrid(tab);
				const met   = Object.assign(getMetrics(tab, grid), cMet);
				const newWs = calcNewWidths(grid, met);
				setCellWidth(grid, newWs);
			
				const cs = tab.getElementsByTagName('caption');
				if (cs.length) cs[0].innerHTML = `<span>${cs[0].innerHTML}</span>`;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function makeCellGrid(t) {
				const css = collectCells(t);
				let maxWidth = 0;
				for (const cs of css) maxWidth = Math.max(maxWidth, cs.length);
				const g = [];
				for (const cs of css) g.push(new Array(maxWidth));
			
				for (let y = 0; y < g.length; y += 1) {
					const gr = g[y];
					const tds = css[y];
					let i = 0;
			
					for (let x = 0; x < maxWidth; x += 1) {
						if (typeof gr[x] === 'number' || gr[x] === null) continue;
			
						const td = tds[i]
						const col = parseInt(td.getAttribute('colSpan') ?? 1, 10);
						const row = parseInt(td.getAttribute('rowSpan') ?? 1, 10);
						gr[x] = td;
			
						if (1 < col) {
							for (let p = 1; p < col; p += 1) gr[x + p] = p;
						}
						if (1 < row) {
							for (let q = 1; q < row; q += 1) {
								const nr = g[y + q];
								for (let p = 0; p < col; p += 1) nr[x + p] = null;
							}
						}
						i += 1;
						if (tds.length <= i) break;
					}
				}
				return g;
			}
			
			function collectCells(t, css = []) {
				for (const tr of t.rows) {
					const cs = [];
					if (tr.hasChildNodes()) {
						for (const n of tr.childNodes) {
							const tn = n.tagName;
							if (tn === 'TD' || tn === 'TH') cs.push(n);
						}
					}
					css.push(cs);
				}
				return css;
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function getMetrics(tab, grid) {
				const origTabW = tab.clientWidth;
				const origCellWs = [];
				for (let x = 0; x < grid[0].length; x += 1) {
					for (let y = 0; y < grid.length; y += 1) {
						const g = grid[y][x];
						if (g instanceof HTMLTableCellElement && !g.getAttribute('colSpan')) {
							origCellWs.push(g.clientWidth);
							break;
						}
					}
				}
				return { origTabW, origCellWs };
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function calcNewWidths(grid, met) {
				for (const gr of grid) {
					for (const gc of gr) {
						if (typeof gc !== 'number' && gc !== null) gc.style.whiteSpace = 'nowrap';
					}
				}
				const gw = grid[0].length;
				const newWs = new Array(gw).fill(0);
				const fixWs = new Array(gw).fill(0);
			
				for (const gr of grid) {
					for (let x = 0; x < gw; x += 1) {
						const td = gr[x];
						if (td === undefined || td === null || typeof td === 'number') continue;
						if (x < gw - 1 && typeof gr[x + 1] === 'number') continue;
						if (1 < parseInt(td.getAttribute('colSpan'), 10)) continue;
						if (1 < parseInt(td.getAttribute('rowSpan'), 10)) continue;
			
						const minW = calcMinWidth(td, met);
						newWs[x] = Math.max(newWs[x], minW);
						if (!minW) fixWs[x] = Math.max(fixWs[x], td.clientWidth);
					}
				}
				widenTabWidth(newWs, fixWs, met);
				return newWs;
			}
			
			function calcMinWidth(td, met) {
				const { padH, padV, charW, lineH, dcTd, dcTh, cellMinWidth, cellMinAspect, cellMinLength } = met;
				if (calcMaxLineLength(td) < cellMinLength) return 0;
			
				td.innerHTML = td.innerHTML.trim();
				const dc = td.tagName === 'TD' ? dcTd : dcTh;
				dc.innerHTML = td.innerHTML;
				const aw = dc.clientWidth - padH;
				const ls = Math.round((dc.clientHeight - padV) / lineH);
				let minW = 0;
				for (let i = 2;; i += 1) {
					const tempW = 0 | (aw / i + charW * i + padH);
					const tempH = ls * (i * lineH) + padV;
					if (tempW < cellMinWidth || tempW / tempH < cellMinAspect || (minW && minW < tempW)) break;
					minW = tempW;
				}
				return (minW + charW < dc.clientWidth) ? minW : 0;
			}
			
			function calcMaxLineLength(td) {
				const ih = td.innerHTML.trim();
				const ls = ih.split(/<\s*br\s*\/?>/ui);
				const ts = ls.map(e => e.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '').length);
				return Math.max(...ts);
			}
			
			function widenTabWidth(newWs, fixWs, met) {
				const { origTabW, origCellWs } = met;
				let wNew = 0, wFix = 0;
				for (let i = 0; i < newWs.length; i += 1) {
					if (newWs[i]) {
						wNew += newWs[i];
					} else {
						wFix += fixWs[i];
					}
				}
				if (origTabW < wNew + wFix) return;
				let rem = origTabW - wFix;
				for (let i = 0; i < newWs.length; i += 1) {
					if (!newWs[i]) continue;
					const nw = newWs[i];
					const w = Math.min(nw / wNew * rem, origCellWs[i]);
					rem  -= (w - nw);
					wNew -= (w - nw);
					newWs[i] = 0 | w;
				}
			}
			
			
			// -------------------------------------------------------------------------
			
			
			function setCellWidth(grid, ws) {
				for (const gr of grid) {
					for (let x = 0; x < gr.length; x += 1) {
						const gc = gr[x], w = ws[x];
						if (!w || !(gc instanceof HTMLTableCellElement)) continue;
						gc.style.whiteSpace = null;
						gc.style.minWidth   = w + 'px';
						gc.style.width      = null;
					}
				}
			}
			NS.table.applyNeatWidth = apply;
		}
		{
			/**
			 * Usable View
			 *
			 * @author Takuto Yanagida
			 * @version 2023-03-01
			 */
			
			function apply(tabs, opts = {}) {
				if (tabs.length === 0) return;
				const cm = Object.assign({
					capableWindowHeightRate: 0.9,
					styleHeaderContainer   : ':ncTableStickyHeaderContainer',
					styleHeaderTable       : ':ncTableStickyHeaderTable',
					styleScrollBar         : ':ncTableStickyScrollBar',
			
					styleScrollRight: ':ncScrollRight',
					styleScrollLeft : ':ncScrollLeft',
					offset          : 0,
				}, opts);
			
				const cs = [], ts = [...tabs];
				for (const tab of ts) {
					const head = _createHeaderClone(tab, cm);
					const bar  = _createBarClone(tab, cm);
					cs.push({ tab, head, bar });
			
					let forced = null;
					const el = (self, op) => throttle(() => {
						if (forced && forced !== self) {
							forced = null;
						} else {
							forced = self;
							op.scrollLeft = self.scrollLeft;
							if (head) onTableScroll(tab, head, cm);
						}
					});
					tab.addEventListener('scroll', el(tab, bar));
					bar.addEventListener('scroll', el(bar, tab));
				}
				const ro = new ResizeObserver((es) => {
					for (const e of es) {
						const idx = ts.indexOf(e.target);
						const c = cs[idx];
						doResize(e.contentRect, c.tab, c.head, c.bar, cm);
					}
				});
				for (const t of ts) ro.observe(t);
			
				window.addEventListener('scroll', throttle(() => {
					let maxHeadH = 0;
					for (const c of cs) {
						onWindowScroll(c.tab, c.head, c.bar, cm);
						maxHeadH = Math.max(maxHeadH, c.head?.offsetHeight ?? 0);
					}
					setScrollPaddingTop('nacss-table', maxHeadH);
				}), { passive: true });
			
				initializeScrollPaddingTop();
			
				let st = null;
				const fn = () => {
					cm.offset = getScrollPaddingTop('nacss-table');
					if (st) clearTimeout(st);
					st = setTimeout(() => {
						for (const c of cs) doResize(null, c.tab, c.head, c.bar, cm);
					}, 100);
				};
				onResize(fn, true);
				const mo = new MutationObserver(fn);
				mo.observe(document.documentElement, { attributes: true });
			}
			
			function _createHeaderClone(tab, cm) {
				let thead = tab.tHead;
				if (!thead) {
					thead = _createPseudoHeader(tab);
					if (!thead) return null;
					tab.tHead = thead;
				}
				const hc = document.createElement('div');
				setClass(hc, cm.styleHeaderContainer);
				tab.parentNode.appendChild(hc);
			
				const ht = document.createElement('div');
				setClass(ht, cm.styleHeaderTable);
				hc.appendChild(ht);
			
				ht.appendChild(thead.cloneNode(true));
				return hc;
			}
			
			function _createPseudoHeader(tab) {
				const trs = tab.tBodies[0].rows;
				if (trs.length === 0) return null;
			
				function containsOnlyTh(tr) {
					const tds = tr.getElementsByTagName('td');
					const ths = tr.getElementsByTagName('th');
					if (tds.length === 0 && ths.length > 0) return true;
					return false;
				}
				const trsH = [];
				for (const tr of trs) {
					if (!containsOnlyTh(tr)) break;
					trsH.push(tr);
				}
				if (trsH.length === 0) return null;
			
				const thead = tab.createTHead();
				for (const tr of trsH) thead.appendChild(tr);
				return thead;
			}
			
			function _createBarClone(tab, cm) {
				const bar = document.createElement('div');
				setClass(bar, cm.styleScrollBar);
				const spacer = document.createElement('div');
				bar.appendChild(spacer);
				tab.parentNode.appendChild(bar);
				return bar;
			}
			
			
			// ---------------------------------------------------------------------
			
			
			function doResize(r, tab, head, bar, cm) {
				tab.style.overflowX = (tab.scrollWidth < tab.clientWidth + 2) ? 'hidden' : null;
			
				if (head) _updateHeaderSize(r, tab, head, cm);
				if (bar) _updateScrollBarSize(tab, bar);
				if (head || bar) onWindowScroll(tab, head, bar, cm);
				if (head) onTableScroll(tab, head, cm);
			}
			
			function _updateHeaderSize(r, tab, head, cm) {
				const tw = r ? r.width : tab.offsetWidth;
				head.style.maxWidth = tw + 'px';
				head.style.display  = 'none';
				head.style.top      = cm.offset + 'px';
			
				const thead = tab.tHead;
				const ht    = head.firstChild;
			
				head.style.setProperty('--nc-width', `${thead.offsetWidth}px`);
				head.style.setProperty('--nc-height', `${thead.offsetHeight}px`);
			
				const oTrs = thead.rows;
				const cTrs = ht.firstChild.rows;
				for (let i = 0; i < oTrs.length; i += 1) {
					copyWidth(oTrs[i], cTrs[i], 'td');
					copyWidth(oTrs[i], cTrs[i], 'th');
				}
				function copyWidth(o, c, tag) {
					const os = o.getElementsByTagName(tag);
					const cs = c.getElementsByTagName(tag);
					for (let i = 0; i < os.length; i += 1) {
						cs[i].style.width = os[i].offsetWidth + 'px';
					}
				}
			}
			
			function _updateScrollBarSize(tab, bar) {
				const disabled = (tab.scrollWidth < tab.clientWidth + 2);
				bar.style.overflowX     = disabled ? 'hidden' : null;
				bar.style.pointerEvents = disabled ? 'none'   : null;
				bar.style.maxWidth      = `${tab.clientWidth}px`;
				bar.style.display       = 'none';
			
				const h = parseInt(getScrollBarWidth(document.documentElement));
				if (0 < h) {
					bar.style.height = (h + 2 + 1) + 'px';
				}
				bar.firstChild.style.width = `${tab.scrollWidth}px`;
			}
			
			
			// ---------------------------------------------------------------------
			
			
			function onWindowScroll(tab, head, bar, cm) {
				const r = tab.getBoundingClientRect();
				const tBottom = r.bottom;
				const rh = (tab.tHead ?? tab.tBodies[0]).getBoundingClientRect();
				const hTop = rh.top, hBottom = rh.bottom;
				const wY0 = cm.offset, wY1 = window.innerHeight;
			
				const inView = tBottom - hTop < cm.capableWindowHeightRate * (wY1 - wY0);
				const tLeft = r.left, tScrollLeft = tab.scrollLeft;
				if (head) {
					const hCy = tab.tHead.offsetHeight;
					const f = (!inView && hTop < wY0 && wY0 < tBottom - hCy);
					_updateHeaderVisibility(head, f, tLeft, tScrollLeft);
				}
				if (bar) {
					const f = (!inView && hBottom < wY1 && wY1 < tBottom);
					_updateBarVisibility(bar, f, tLeft, tScrollLeft);
				}
			}
			
			function _updateHeaderVisibility(head, visible, tabLeft, tabScrollLeft) {
				head.style.display = visible ? 'block' : 'none';
				head.style.left    = tabLeft + 'px';
				head.scrollLeft    = tabScrollLeft;
			}
			
			function _updateBarVisibility(bar, visible, tabLeft, tabScrollLeft) {
				bar.style.display = visible ? 'block' : 'none';
				bar.style.left    = tabLeft + 'px';
				bar.scrollLeft    = tabScrollLeft;
			}
			
			
			// ---------------------------------------------------------------------
			
			
			function onTableScroll(tab, head, cm) {
				const sL = Math.max(0, Math.min(tab.scrollLeft, tab.scrollWidth - tab.offsetWidth));  // for iOS
				head.scrollLeft = sL;
			
				if (tab.scrollWidth - tab.clientWidth > 2) {  // for avoiding needless scrolling
					const r = tab.scrollLeft / (tab.scrollWidth - tab.clientWidth);
					setClass(head, cm.styleScrollRight, r < 0.95);
					setClass(head, cm.styleScrollLeft, 0.05 < r);
				} else {
					setClass(head, cm.styleScrollRight, false);
					setClass(head, cm.styleScrollLeft, false);
				}
			}
			
			
			// Utilities ---------------------------------------------------------------
			
			
			function getScrollBarWidth(parent) {
				const d = document.createElement('div');
				d.setAttribute('style', 'position:absolute;bottom:100%;width:calc(100vw - 100%);height:1px;');
				parent.appendChild(d);
				let width = 0 | window.getComputedStyle(d).getPropertyValue('width');
			
				if (width === 0) {  // Window does not have any scroll bar
					d.style.overflowY = 'scroll';
					d.style.width = '';
					const c = document.createElement('div');
					c.style.minHeight = '100px';
					d.appendChild(c);
					const cw = 0 | window.getComputedStyle(c).getPropertyValue('width');
					width = d.offsetWidth - cw;
				}
				parent.removeChild(d);
				return width;
			}
			NS.table.applyUsableView = apply;
		}
	}

	// Viewer ------------------------------------------------------------------
	NS['viewer'] = {};
	{
		/**
		 *
		 * Functions for Hash
		 *
		 * @author Takuto Yanagida
		 * @version 2022-08-17
		 *
		 */
		
		
		function calcHash(str, asHex = true) {
			let h = 0x811c9dc5;
			for (let i = 0; i < str.length; i += 1) {
				h ^= str.charCodeAt(i);
				h += (h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24);
			}
			if (asHex) {
				const hex = '0000000' + (h >>> 0).toString(16);
				return hex.substring(hex.length - 8);
			}
			return h >>> 0;
		}
		
		const cache = new Map();
		
		function calcHashSet(str, asHex = true) {
			if (cache.has(str)) {
				const n = cache.get(str);
				cache.set(str, n + 1);
				return calcHash(str + n, asHex);
			} else {
				cache.set(str, 1);
				return calcHash(str, asHex);
			}
		}
		
		/**
		 *
		 * Style Class Utilities
		 *
		 * @author Takuto Yanagida
		 * @version 2021-11-11
		 *
		 */
		
		
		function hasClass(tar, cls) {
			const key = cls.substr(1);
			if (cls.startsWith(':')) {
				return tar.dataset[key] !== undefined;
			} else {
				return tar.classList.contains(key);
			}
		}
		
		function setClass(tar, cls, enabled = true, val = '') {
			const key = cls.substr(1);
			if (cls.startsWith(':')) {
				if (enabled) {
					tar.dataset[key] = val;
				} else {
					delete tar.dataset[key];
				}
			} else {
				const c = [key, val].join('-');
				if (enabled) {
					tar.classList.add(c);
				} else {
					tar.classList.remove(c);
				}
			}
		}
		
		function getSelector(cls) {
			if (cls.startsWith(':')) {
				return `*[data-${cls.substr(1).replace(/([A-Z])/g, c => '-' + c.charAt(0).toLowerCase())}]`;
			} else {
				return `*${cls}`;
			}
		}
		
		/**
		 *
		 * Functions for Touch Support
		 *
		 * @author Takuto Yanagida
		 * @version 2023-07-18
		 *
		 */
		
		
		function getTouchPoint(ts) {
			const pxo = window.scrollX, pyo = window.scrollY;
			let x = 0, y = 0;
			if (ts.length === 1) {
				x = ts[0].pageX - pxo;
				y = ts[0].pageY - pyo;
			} else if (2 <= ts.length) {
				x = (ts[0].pageX + ts[1].pageX) / 2 - pxo;
				y = (ts[0].pageY + ts[1].pageY) / 2 - pyo
			}
			return [x, y];
		}
		
		function touchDistance(ts) {
			const x1 = ts[0].screenX, y1 = ts[0].screenY;
			const x2 = ts[1].screenX, y2 = ts[1].screenY;
			return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
		}
		
		function preventWindowTouchMove(f) {
			let isTouching = false;
			window.addEventListener('touchmove', (e) => {
				if (!isTouching) return;
				e.preventDefault();
				e.stopImmediatePropagation();
			}, { passive: false });
			f.addEventListener('touchstart', () => { isTouching = true; });
			f.addEventListener('touchend', () => { isTouching = false; });
		}
		
		function getCursorPoint(e) {
			return [e.pageX - window.scrollX, e.pageY - window.scrollY];
		}
		
		/**
		 *
		 * Utilities
		 *
		 * @author Takuto Yanagida
		 * @version 2021-12-06
		 *
		 */
		
		
		function getScrollOffset() {
			const s   = getComputedStyle(document.documentElement);
			const val = parseInt(s.scrollPaddingTop);
			return Number.isNaN(val) ? 0 : val;
		}
		
		
		// -----------------------------------------------------------------------------
		
		
		function throttle(fn) {
			let isRunning;
			return (...args) => {
				if (isRunning) return;
				isRunning = true;
				requestAnimationFrame(() => {
					isRunning = false;
					fn(...args);
				});
			};
		}
		
		const resizeListeners = [];
		
		function onResize(fn, doFirst = false) {
			if (doFirst) fn();
			resizeListeners.push(throttle(fn));
		}
		
		document.addEventListener('DOMContentLoaded', () => {
			window.addEventListener('resize', () => {
				for (const l of resizeListeners) l();
			}, { passive: true });
		});
		
		{
			/**
			 *
			 * Image Viewer
			 *
			 * @author Takuto Yanagida
			 * @version 2022-08-17
			 *
			 */
			
			
			function apply(as, opts = {}) {
				if (as.length === 0) return;
			
				opts = Object.assign({
					styleOpener       : ':ncViewerOpener',
					styleOpenerWrapper: ':ncViewerOpenerWrapper',
				}, opts);
			
				const fs = as.map(a => {
					const id = calcHashSet(a.href);
					const [frameInst, frame] = createImageFrame(opts, a.href);
					const caption = extractImageCaption(a);
					assignImageOpenerStyle(a, opts['styleOpener'], opts['styleOpenerWrapper']);
			
					return { opener: a, id, frameInst, frame, caption };
				});
				initialize(fs, opts);
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function createImageFrame(opts, src) {
				opts = Object.assign({
					styleImageFrame: ':ncFrameImage',
					styleLoaded    : ':ncLoaded',
					maxZoomRate    : 10,
				}, opts);
			
				const inst = {
					opts, src,
			
					scale    : 1,
					realScale: 1,
					baseSize : null,
					isLs     : false,
					margin   : 0,
			
					frm: null,
					img: null,
				};
			
				inst.frm = document.createElement('div');
				setClass(inst.frm, inst.opts.styleImageFrame);
			
				inst.img = document.createElement('img');
				inst.img.addEventListener('click', e => e.stopPropagation());
				inst.frm.appendChild(inst.img);
			
				_enableMouseGesture(inst, inst.frm);
				_enableTouchGesture(inst, inst.frm);
			
				inst['doResize'] = () => setSize(inst);
				inst['doOpen']   = () => setSource(inst);
				inst['doClose']  = () => {};
				return [inst, inst.frm];
			}
			
			function extractImageCaption(a) {
				if (a.parentNode.tagName === 'FIGURE') {
					const fcs = a.parentNode.getElementsByTagName('figcaption');
					if (0 < fcs.length) {
						return fcs[0].innerHTML;
					}
				}
				return null;
			}
			
			function assignImageOpenerStyle(a, styleOpener, styleOpenerWrapper) {
				setClass(a, styleOpener);
				if (a.parentNode.tagName === 'FIGURE') {
					setClass(a.parentNode, styleOpenerWrapper);
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function setSize(inst) {
				const winAs = inst.frm.offsetWidth / inst.frm.offsetHeight;
				const imgAs = inst.img.offsetWidth / inst.img.offsetHeight;
				inst.isLs = (winAs < imgAs);
			
				const cs = getComputedStyle(inst.img);
				inst.margin = parseInt(cs.outlineWidth) * 2;
			
				const s = inst.img.style;
				s.minWidth  = '';
				s.minHeight = '';
				if (inst.isLs) {
					s.width  = `calc(100% - ${inst.margin}px)`;
					s.height = 'auto';
				} else {
					s.width    = 'auto';
					s.height   = `calc(100% - ${inst.margin}px)`;
					s.maxWidth = 'none';
				}
			
				inst.baseSize = inst.isLs ? inst.frm.clientWidth  : inst.frm.clientHeight;
				const nbs     = inst.isLs ? inst.img.naturalWidth : inst.img.naturalHeight;
			
				inst.realScale = nbs / inst.baseSize;
				inst.scale     = 1;
				_doCenteringImage(inst.frm, inst.img);
			}
			
			function setSource(inst) {
				const img = inst.img;
				if (!img.src) {
					img.style.opacity = '0';
					img.src = inst.src;
					img.addEventListener('load', () => {
						setSize(inst);
						setClass(inst.frm, inst.opts.styleLoaded);
						setTimeout(() => { img.style.opacity = '1'; }, 0);
					});
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function _setScaledSize(inst, scale) {
				inst.scale = Math.max(1, Math.min(inst.opts.maxZoomRate, scale));
			
				const size = (inst.baseSize * inst.scale - inst.margin) + 'px';
				if (inst.isLs) {
					inst.img.style.minWidth = size;
				} else {
					inst.img.style.minHeight = size;
				}
				_doCenteringImage(inst.frm, inst.img);
			}
			
			function _doCenteringImage(frm, img) {
				const imgW = img.offsetWidth, imgH = img.offsetHeight;
				const frmW = frm.clientWidth, frmH = frm.clientHeight;
				const s = img.style;
				s.left = (imgW < frmW) ? (((frmW - imgW) / 2) + 'px') : 0;
				s.top  = (imgH < frmH) ? (((frmH - imgH) / 2) + 'px') : 0;
			}
			
			function _enableMouseGesture(inst, frm) {
				let xS = 0, yS = 0;
				let isMoving = false;
			
				frm.addEventListener('mousedown', e => {
					if (e.button) return;  // when button is not left
					e.preventDefault();
					[xS, yS] = getCursorPoint(e);
					isMoving = true;
				});
				frm.addEventListener('mousemove', e => {
					if (!isMoving) return;
					e.stopPropagation();
					e.preventDefault();
			
					const [cx, cy] = getCursorPoint(e);
					frm.scrollLeft += xS - cx;
					frm.scrollTop  += yS - cy;
					xS = cx;
					yS = cy;
				});
				frm.addEventListener('mousedrag', e => {
					if (!isMoving) return;
					e.stopPropagation();
					e.preventDefault();
				});
				frm.addEventListener('mouseup', () => { isMoving = false; });
			
				frm.addEventListener('wheel', e => {
					const s = 0 > e.deltaY ? 1.1 : 0.9;
					zoomListener(e, inst.scale * s);
				}, true);
				frm.addEventListener('dblclick', e => {
					if (inst.realScale < 1) return;
					zoomListener(e, inst.scale < inst.realScale ? inst.realScale : 1);
				}, true);
			
				function zoomListener(e, scale) {
					e.stopPropagation();
					e.preventDefault();
			
					const [cx, cy] = getCursorPoint(e);
					const ix = (cx + frm.scrollLeft) / inst.scale;
					const iy = (cy + frm.scrollTop)  / inst.scale;
			
					_setScaledSize(inst, scale);
			
					frm.scrollLeft = ix * inst.scale - cx;
					frm.scrollTop  = iy * inst.scale - cy;
				}
			}
			
			function _enableTouchGesture(inst, frm) {
				let ix = 0, iy = 0;
				let lastTouchCount = 0;
				let baseDist = 0;
			
				preventWindowTouchMove(frm);  // for Android
			
				frm.addEventListener('touchstart', e => {
					baseDist = 0;
					updatePoint(e.touches);
				});
				frm.addEventListener('touchmove', e => {
					e.preventDefault();
					e.stopPropagation();
			
					const ts = e.touches;
					if (lastTouchCount !== ts.length) {
						updatePoint(ts);
					}
					const [cx, cy] = getTouchPoint(ts);
			
					if (2 <= ts.length) {
						const dist = touchDistance(ts);
						if (baseDist) {
							const s = dist / (baseDist * inst.scale);
							if (s && s !== Infinity) {
								_setScaledSize(inst, inst.scale * s);
							}
							frm.scrollLeft = ix * inst.scale - cx;
							frm.scrollTop  = iy * inst.scale - cy;
						}
						baseDist = dist / inst.scale;
					} else {
						frm.scrollLeft = ix * inst.scale - cx;
						frm.scrollTop  = iy * inst.scale - cy;
					}
				}, { passive: false });
			
				function touchPointToImagePoint(x, y) {
					const fsx = frm.scrollLeft;
					const fsy = frm.scrollTop;
					const ix = (x + fsx) / inst.scale;
					const iy = (y + fsy) / inst.scale;
					return [ix, iy];
				}
			
				function updatePoint(ts) {
					lastTouchCount = ts.length;
					[ix, iy] = touchPointToImagePoint(...getTouchPoint(ts));
				}
			}
			
			NS.viewer.applyImage = apply;
		}
		{
			/**
			 *
			 * Iframe Viewer
			 *
			 * @author Takuto Yanagida
			 * @version 2022-08-17
			 *
			 */
			
			
			function apply(os, ifms, opts = {}) {
				if (os.length === 0) return;
			
				opts = Object.assign({
					styleOpener       : ':ncViewerOpener',
					styleOpenerWrapper: ':ncViewerOpenerWrapper',
				}, opts);
			
				const fs = os.map((o, i) => {
					const id = calcHashSet(ifms[i].src);
					const [frameInst, frame] = createIframeFrame(opts, ifms[i]);
					assignIframeOpenerStyle(o, opts['styleOpener']);
			
					return { opener: o, id, frameInst, frame, caption: null };
				});
				initialize(fs, opts);
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function createIframeFrame(opts, ifm) {
				opts = Object.assign({
					styleIframeFrame: ':ncFrameIframe',
					styleLoaded     : ':ncLoaded',
				}, opts);
			
				const src = filterSource(ifm.src);
			
				ifm.removeAttribute('src');
				ifm.setAttribute('data-nc-lazy', '');
				if (!ifm.style.aspectRatio) {
					const [w, h] = extractIframeSize(ifm);
					if (w && h) {
						ifm.style.aspectRatio = `${w} / ${h}`;
					}
				}
			
				const inst = {
					opts, src, ifm,
			
					scale    : 1,
					realScale: 1,
					baseSize : null,
					isLs     : false,
					margin   : 0,
			
					frm: null,
				};
			
				inst.frm = document.createElement('div');
				setClass(inst.frm, inst.opts.styleIframeFrame);
			
				inst.ifm.addEventListener('click', e => e.stopPropagation());
				inst.frm.appendChild(inst.ifm);
			
				inst['doResize'] = () => {};
				inst['doOpen']   = () => setSource(inst);
				inst['doClose']  = () => pause(inst);
				return [inst, inst.frm];
			}
			
			function assignIframeOpenerStyle(o, styleOpener) {
				setClass(o, styleOpener);
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function setSource(inst) {
				const ifm = inst.ifm;
				if (ifm.hasAttribute('data-nc-lazy')) {
					ifm.removeAttribute('data-nc-lazy');
					ifm.style.opacity = '0';
					ifm.addEventListener('load', () => {
						setClass(inst.frm, inst.opts.styleLoaded);
						setTimeout(() => { ifm.style.opacity = '1'; }, 0);
					});
					ifm.contentDocument.location.replace(inst.src);
				}
			}
			
			function pause(inst) {
				if (inst.src.startsWith('https://www.youtube.com')) {
					inst.ifm.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
				}
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function filterSource(src) {
				if (src.startsWith('https://www.youtube.com')) {
					const url = new URL(src);
					const ps  = new URLSearchParams(url.search);
					ps.append('enablejsapi', 1);
					url.search = ps;
					src = url.toString();
				}
				return src;
			}
			
			function extractIframeSize(f) {
				let w = parseInt(f.width);
				let h = parseInt(f.height);
				if (w && h) return [w, h];
			
				const sW = f.style.width;
				const sH = f.style.height;
				if (sW.indexOf('px') !== sW.length - 2) return [0, 0];
				if (sH.indexOf('px') !== sH.length - 2) return [0, 0];
				w = parseInt(sW);
				h = parseInt(sH);
				if (w && h) return [w, h];
				return [0, 0];
			}
			
			NS.viewer.applyIframe = apply;
		}
		/**
		 *
		 * Dialog
		 *
		 * @author Takuto Yanagida
		 * @version 2022-08-17
		 *
		 */
		
		
		function initialize(fs, opts = {}) {
			if (fs.length === 0) return;
		
			opts = Object.assign({
				styleRoot   : ':ncViewer',
				styleCloser : ':ncViewerCloser',
				stylePrev   : ':ncViewerPrev',
				styleNext   : ':ncViewerNext',
				styleCaption: ':ncViewerCaption',
		
				styleOpen     : ':ncOpen',
				styleVisible  : ':ncVisible',
				styleInstantly: ':ncInstantly',
		
				hashPrefix: 'viewer:',
			}, opts);
		
			const is = new Map();
			let prev = null;
			for (const f of fs) {
				const inst = createViewer(opts, f.id, f.frameInst, f.frame, f.caption, prev);
				f.opener.addEventListener('click', e => _onOpen(inst, e));
				is.set(f.id, inst);
				prev = inst;
			}
			assignEventHandler(is);
			processHash(is, opts['hashPrefix']);
		}
		
		function assignEventHandler(is) {
			onResize(() => {
				for (const inst of is.values()) inst.fi.doResize();
				setTimeout(() => {
					for (const inst of is.values()) inst.fi.doResize();
				}, 200);
			});
			window.addEventListener('keydown', e => {
				if (currentId !== null && !e.altKey && !e.ctrlKey && !e.shiftKey) {
					const cur = is.get(currentId);
					if (e.key === 'Escape') cur.dlg.click();
					else if (e.key === 'ArrowLeft') cur.btnPrev.click();
					else if (e.key === 'ArrowRight') cur.btnNext.click();
				}
			});
		}
		
		function processHash(is, hashPrefix) {
			window.addEventListener('popstate', e => {
				if (currentId !== null && is.has(currentId)) {
					doClose(is.get(currentId));
				}
				if (e.state && e.state['name'] === 'nc-viewer' && e.state['id'] !== undefined && is.has(e.state['id'])) {
					doOpen(is.get(e.state['id']));
				}
			});
			window.addEventListener('hashchange', () => checkHash(is, hashPrefix, location.hash));
			checkHash(is, hashPrefix, location.hash);
		}
		
		function checkHash(is, hashPrefix, hash) {
			if (location.hash.indexOf('#' + hashPrefix) !== 0) return;
			const h = hash.replace('#' + hashPrefix, '');
			if (!h) return;
			for (const [id, inst] of is) {
				if (id === h) {
					if (currentId !== null && currentId !== id) doClose(is.get(currentId));
					if (currentId === null || currentId !== id) doOpen(inst);
					break;
				}
			}
		}
		
		
		// -----------------------------------------------------------------------------
		
		
		let currentId = null;
		
		function createViewer(opts, id, frameInst, frame, caption, prevInstance = null) {
			const inst = {};
			inst.opts = opts;
			inst.fi   = frameInst;
			inst.id   = id;
		
			inst.dlg = document.createElement('div');
			setClass(inst.dlg, opts.styleRoot);
			inst.dlg.addEventListener('click', e => _onClose(e));
			inst.dlg.appendChild(frame);
		
			const btn = document.createElement('button');
			setClass(btn, opts.styleCloser);
			inst.dlg.appendChild(btn);
		
			inst.btnPrev = document.createElement('button');
			inst.btnNext = document.createElement('button');
			setClass(inst.btnPrev, opts.stylePrev);
			setClass(inst.btnNext, opts.styleNext);
			inst.dlg.appendChild(inst.btnPrev);
			inst.dlg.appendChild(inst.btnNext);
		
			if (caption) {
				const divCap = document.createElement('div');
				divCap.innerHTML = `<span>${caption}</span>`;
				setClass(divCap, opts.styleCaption);
				inst.dlg.appendChild(divCap);
			}
			document.body.appendChild(inst.dlg);
		
			_setAdjacentInstance(inst, prevInstance);
			prevInstance = inst;
			return inst;
		}
		
		
		// -----------------------------------------------------------------------------
		
		
		function doOpen(inst, instantly = false) {
			setClass(inst.dlg, inst.opts.styleOpen);
			inst.fi.doOpen();
		
			if (instantly) {
				inst.fi.doResize();
				setClass(inst.dlg, inst.opts.styleInstantly);
				setClass(inst.dlg, inst.opts.styleVisible);
				setTimeout(() => { setClass(inst.dlg, inst.opts.styleInstantly, false); }, 20);
		
				const url = '#' + inst.opts.hashPrefix + inst.id;
				history.replaceState(null, '', url);
			} else {
				setTimeout(() => {
					inst.fi.doResize();
					setClass(inst.dlg, inst.opts.styleVisible);
				}, 0);
			}
			currentId = inst.id;
		
			const sty = getComputedStyle(document.documentElement);
			if (sty.marginTop) {
				inst.dlg.style.top = sty.marginTop;
			}
		}
		
		function doClose(inst, instantly = false) {
			inst.fi.doClose();
		
			if (instantly) {
				setClass(inst.dlg, inst.opts.styleInstantly);
				setClass(inst.dlg, inst.opts.styleVisible, false);
				setTimeout(() => { setClass(inst.dlg, inst.opts.styleInstantly, false); }, 20);
			} else {
				setClass(inst.dlg, inst.opts.styleVisible, false);
			}
			setTimeout(() => { setClass(inst.dlg, inst.opts.styleOpen, false); }, 200);
			currentId = null;
		}
		
		
		// -----------------------------------------------------------------------------
		
		
		function _setAdjacentInstance(inst, prev) {
			inst.btnNext.style.display = 'none';
			if (prev) {
				inst.btnPrev.addEventListener('click', e => {
					e.stopPropagation();
					doClose(inst, true);
					doOpen(prev, true);
				});
				_setNextInstance(prev, inst);
			} else {
				inst.btnPrev.style.display = 'none';
			}
		}
		
		function _setNextInstance(inst, next) {
			inst.btnNext.addEventListener('click', e => {
				e.stopPropagation();
				doClose(inst, true);
				doOpen(next, true);
			});
			inst.btnNext.style.display = null;
		}
		
		function _onOpen(inst, e) {
			e.preventDefault();
			doOpen(inst);
		
			if (location.hash) {
				const newUrl = location.href.substring(0, location.href.indexOf('#'));
				history.replaceState(null, '', newUrl);
			}
			const url = '#' + inst.opts.hashPrefix + inst.id;
			history.pushState({ name: 'nc-viewer', id: inst.id }, null, url);
		}
		
		function _onClose(e) {
			e.preventDefault();
			history.back();
		}
		
	}

	// Utility -----------------------------------------------------------------
	NS['utility'] = {};
	{
		/**
		 * Utilities
		 *
		 * @author Takuto Yanagida
		 * @version 2023-02-01
		 */
		
		function getScrollOffset() {
			const s   = getComputedStyle(document.documentElement);
			const val = parseInt(s.scrollPaddingTop);
			return Number.isNaN(val) ? 0 : val;
		}
		
		function onLoad(fn) {
			if ('loading' === document.readyState) {
				document.addEventListener('DOMContentLoaded', fn);
			} else {
				setTimeout(fn, 0);
			}
		}
		
		
		// -----------------------------------------------------------------------------
		
		
		function throttle(fn) {
			let isRunning;
			return (...args) => {
				if (isRunning) return;
				isRunning = true;
				requestAnimationFrame(() => {
					isRunning = false;
					fn(...args);
				});
			};
		}
		
		const resizeListeners = [];
		
		function onResize(fn, doFirst = false) {
			if (doFirst) fn();
			resizeListeners.push(throttle(fn));
		}
		
		document.addEventListener('DOMContentLoaded', () => {
			window.addEventListener('resize', () => {
				for (const l of resizeListeners) l();
			}, { passive: true });
		});
		
		
		// -----------------------------------------------------------------------------
		
		
		function onIntersect(fn, targets, threshold = 0, rootMargin ='* 0px 0px 0px') {
			const vs = Array(targets.length).fill(false);
			const tm = new Map();
			targets.forEach((t, i) => tm.set(t, i));
		
			function init() {
				const io = new IntersectionObserver((es) => {
					for (const e of es) vs[tm.get(e.target)] = e.isIntersecting;
					fn(vs);
				}, { rootMargin: rootMargin.replace('*', `${mt}px`), threshold });
				for (const t of targets) io.observe(t);
				return io;
			}
			let mt = 0;
			let io = null;
			let st = null;
			onResize(() => {
				mt = -getScrollOffset();
				if (st) clearTimeout(st);
				st = setTimeout(() => {
					if (io) io.disconnect();
					io = init();
				}, 100);
			}, true);
		}
		
		{
			/**
			 * Inner
			 *
			 * @author Takuto Yanagida
			 * @version 2021-11-25
			 */
			
			function getBreakPointSize() {
				let bpW, bpH;
			
				const w = window.innerWidth;
				if (w < 450) {
					bpW = 'phone-portrait';
				} else if (w < 600) {
					bpW = 'phone-landscape';
				} else if (w < 900) {
					bpW = 'tablet-portrait';
				} else if (w < 1200) {
					bpW = 'tablet-landscape';
				} else if (w < 1500) {
					bpW = 'desktop';
				} else {
					bpW = 'big-desktop';
				}
				const h = window.innerHeight;
				if (h < 700) {
					bpH = 'tiny';
				} else if (h < 800) {
					bpH = 'small';
				} else if (h < 900) {
					bpH = 'medium';
				} else {
					bpH = 'large';
				}
				return [bpW, bpH];
			}
			
			
			// -----------------------------------------------------------------------------
			
			
			function getBrowser() {
				const ua = window.navigator.userAgent.toLowerCase();
				if (ua.includes('chrome')) {  // UA includes 'safari'.
					return 'chrome';
				}
				if (ua.includes('safari')) {
					return 'safari';
				}
				if (ua.includes('firefox')) {
					return 'firefox';
				}
			}
			
			function getDevice() {
				const ua = window.navigator.userAgent.toLowerCase();
			
				const ret = [];
				if (ua.includes('android')) {
					ret.push('android');
				}
				if (ua.includes('iphone')) {
					ret.push('ios');
					ret.push('iphone');
				} else if (ua.includes('ipad')) {
					ret.push('ios');
					ret.push('ipad');
				} else if (ua.includes('safari') && !ua.includes('chrome') && 'ontouchend' in document) {
					ret.push('ios');
					ret.push('ipad');
					ret.push('ipad-desktop');
				}
				if (!ret.length) {
					ret.push('desktop');
				}
				return ret;
			}
			
			NS['BROWSER'] = getBrowser();
			NS['DEVICE']  = getDevice();

			onResize(() => {
				[NS['BP_WIDTH'], NS['BP_HEIGHT']] = getBreakPointSize();
			}, true);
		}
		{
			/**
			 * Polyfill of pseudo class 'blank'
			 *
			 * @author Takuto Yanagida
			 * @version 2023-02-10
			 */
			
			function apply(opts = {}) {
				opts = Object.assign({
					root    : document.documentElement,
					styleKey: ':ncBlank',
				}, opts);
			
				onLoad(() => {
					apply(opts.root);
					const mo = new MutationObserver(ms => {
						for (const m of ms) {
							if ('childList' === m.type) apply(m.target);
						}
					});
					mo.observe(opts.root, { childList: true });
				});
			
				function apply(elm) {
					const ts = elm.querySelectorAll(getSelector(opts.styleKey));
					for (const t of ts) {
						if (!t.children.length) {
							while (t.firstChild) t.removeChild(t.firstChild);
						}
						setClass(t, opts.styleKey, false)
					}
				}
			}
			
			NS.utility.applyBlank = apply;
		}
		{
			/**
			 * Custom property of element dimensions
			 *
			 * @author Takuto Yanagida
			 * @version 2023-02-10
			 */
			
			function apply(opts = {}) {
				opts = Object.assign({
					root: document.documentElement,
					key : 'ncDim',
				}, opts);
			
				const ro = new ResizeObserver(es => {
					for (const e of es) {
						calc(e.target);
					}
				});
			
				onLoad(() => {
					add(opts.root);
			
					const mo = new MutationObserver(es => {
						for (const e of es) {
							if ('childList' === e.type) {
								add(e.target);
							}
						}
					});
					mo.observe(opts.root, { childList: true });
				});
			
				function add(root) {
					if (root.dataset[opts.key]) {
						ro.observe(root, { box: 'border-box' });
					}
					const ts = root.querySelectorAll(`*[data-${opts.key.replace(/([A-Z])/g, c => '-' + c.charAt(0).toLowerCase())}]`);
					for (const t of ts) {
						ro.observe(t, { box: 'border-box' });
					}
				}
			
				function calc(elm) {
					const q = elm.dataset[opts.key];
					if (!q) return;
			
					const qs  = q.split(';').map(e => e.trim()).filter(e => e.length);
					const qss = qs.map(e => e.split(':').map(e => e.trim()));
			
					for (let [cp, ep] of qss) {
						if (!cp.startsWith('--')) {
							cp = '--' + cp;
						}
						if (ep in elm && !isNaN(elm[ep])) {
							opts.root.style.setProperty(cp, elm[ep] + 'px');
						} else {
							if (!(ep in elm)) {
								console.log(`nacss.utility.dimension: property '${ep}' does not exists in the element`);
							} else if (isNaN(elm[ep])) {
								console.log(`nacss.utility.dimension: property '${ep}' is not a number`);
							}
						}
					}
				}
			}
			
			NS.utility.applyDimension = apply;
		}
	}

})(window['ST']);
